import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Suikoden V any%" mdxType="SEO" />
    <h3 {...{
      "id": "sol-falena"
    }}>{`Sol-Falena`}</h3>
    <p>{`Ferid Option 1`}<br parentName="p"></br>{`
`}{`Arshtat Option 1`}</p>
    <h3 {...{
      "id": "lordlake"
    }}>{`Lordlake`}</h3>
    <p>{`Run to Lore Revere's Manse, Option 1`}<br parentName="p"></br>{`
`}{`Go to Balcony, watch Cutscene. After cutscene, pick up `}<strong parentName="p">{`Sacrificial Jizo`}</strong>{` on ramp to the southwest.`}</p>
    <p>{`Lord Revere's Balcony exit is near bottom of screen`}</p>
    <p>{`Head to dock for Talgeyl / Goesch cutscene.`}<br parentName="p"></br>{`
`}{`Option 1 to let Lyon look for Tomo`}<br parentName="p"></br>{`
`}{`Go to Withered Forest`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap"
      }}>{`Swap`}</h5>
      <p>{`Sialeeds > Entourage`}</p>
    </Menu>
    <h3 {...{
      "id": "withered-forest"
    }}>{`Withered Forest`}</h3>
    <p>{`Down, cross bridge, left then right all the way.`}<br parentName="p"></br>{`
`}{`Option 1 to save Toma`}</p>
    <blockquote>
      <p parentName="blockquote">{`Don't forget this game has memory cursor :)`}<br parentName="p"></br>{`
`}{`Tested attacking 3rd Ulse with others, same speed/slower and chance of Prince dying.`}</p>
    </blockquote>
    <h4 {...{
      "id": "3-ulse"
    }}>{`3 Ulse`}</h4>
    <ul>
      <li parentName="ul">{`T1 & 2: Georg Attack, rest Defend`}</li>
      <li parentName="ul">{`T3: Auto`}</li>
    </ul>
    <h3 {...{
      "id": "sol-falena-1"
    }}>{`Sol-Falena`}</h3>
    <p>{`Arshtat: "It serves them right", Lyon: "Your Majesty" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Lyon: "People who had nothing to do with the uprising." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Sialeeds: "Heh, like I need to ask..." Option 1`}</p>
    <blockquote>
      <p parentName="blockquote">{`According to LCC's notes, this is 1s slower. According to CTW, this saves 2s later via Lym affection stuff.`}</p>
    </blockquote>
    <p>{`West upstairs to princess's (last) room, talk to closest girl there. Option 1`}<br parentName="p"></br>{`
`}{`Go up middle area spiral stairs to Sun Rune room and go through dialogues.`}<br parentName="p"></br>{`
`}{`East and downstairs to far east knight's room.`}</p>
    <p>{`Lyon: "Wow, they talk like this in the HALLS now?" Option 1`}<br parentName="p"></br>{`
`}{`Kyle: "Hey, you guys should come visit the Queen's Knights' guard room with me!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`3 minute break from entering guard room to Option 2, 2m after.`}</p>
    </blockquote>
    <p>{`Zahak: "We are terribly sorry, your highness." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`When Kyle leaves your party and you get control leave Guard Room right away.`}<br parentName="p"></br>{`
`}{`Lyon: "Gee, the princess is sure crazy..." Option 1`}</p>
    <p>{`Miakis: "Oh my, my, my!" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Lym: "Hey, Hero. What about you? Would you hate it..." Option 1`}</p>
    <p>{`Once everyone joins your party, leave the guard room.`}</p>
    <p>{`Lym: "Hero, Aunt Sialeeds is scaring me!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Do this menu anytime between now and when Miakis leaves your party after Senate.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip-all"
      }}>{`Unequip All`}</h5>
      <ul>
        <li parentName="ul">{`Kyle`}</li>
        <li parentName="ul">{`Miakis`}</li>
      </ul>
      <h5 {...{
        "id": "all-best"
      }}>{`All Best`}</h5>
      <ul>
        <li parentName="ul">{`Hero`}</li>
        <li parentName="ul">{`Lyon`}</li>
      </ul>
    </Menu>
    <p>{`Go to Senate.`}</p>
    <ol>
      <li parentName="ol">{`Talk to Official slightly below entrance on the way to stairs down.`}</li>
      <li parentName="ol">{`Enter Center Room for Barows cutscene.`}</li>
    </ol>
    <p>{`Salum: "Lucky man today...", "Yes, hahaha..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Sialeeds: "Hero, Lym, what did you think?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Talk to Official southwest of center room, standing by bottom floor exit.`}</li>
      <li parentName="ol">{`Go upstairs on left side and walk to North guy blocking door to trigger cutscene.`}</li>
    </ol>
    <p>{`Official (2 textboxes total): "I'm so very sorry!..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Official: "Well, let's see. We have about 70 applications." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Exit Senate, going around bottom side (don't take stairs) and first exit.`}</p>
    <p>{`Miakis: "Princess, you should get back to your room.", Lym: "Yeah, guess you're right..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`After Sialeeds leaves, Lyon: "Prince, what do you want to do now?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`After scene go south to next screen, west then south across bridge and west to rune shop. Exit rune shop.`}</p>
    <p>{`Kyle: "Hey Prince, I'm gonna go check this out." Option 1`}</p>
    <h4 {...{
      "id": "important-dont-fight-thugs"
    }}>{`IMPORTANT, DON'T FIGHT THUGS`}</h4>
    <p>{`Kyle: "Your Highness, how do you want to handle this?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Run back to Palace same way you came.`}</p>
    <p>{`Lyon: "But, of course, you know I'll protect you no matter what happens!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-1"
      }}>{`Swap`}</h5>
      <p>{`Sialeeds > Entourage`}</p>
    </Menu>
    <p>{`South all the way to pier.`}</p>
    <blockquote>
      <p parentName="blockquote">{`1m15s from getting on ship to dialogue option. 1m45s after dialogue to Zadom. 1m5s after Zadom.`}</p>
    </blockquote>
    <p>{`Lyon: "Her Majesty is really very kind. Right, Prince?" Option 1`}</p>
    <h4 {...{
      "id": "zadom-1000hp"
    }}>{`Zadom 1000HP`}</h4>
    <p>{`Auto`}</p>
    <blockquote>
      <p parentName="blockquote">{`Option 1 is faster by 1s, assume this is for affection.`}</p>
    </blockquote>
    <p>{`Georg: "Hmmm...", "Hero, what do you think?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "stormfist"
    }}>{`Stormfist`}</h3>
    <p>{`Gizel: "We'll have a banquet tonight. Until then..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Left for scene, enter Arena.`}</p>
    <h4 {...{
      "id": "arena"
    }}>{`Arena`}</h4>
    <p>{`Go left for scene. ~1m30s before dialogue.`}<br parentName="p"></br>{`
`}{`Gizel: "Your Royal Highness, what do you say?." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`After scene go down to Stands for cutscene.`}<br parentName="p"></br>{`
`}{`Euram: "You honor me, big brother!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go right to leave stands, go downstairs. Go north to screen above, go right right away to enter Infirmary. Go to Basement.`}</p>
    <p>{`Go right twice to trigger 2 different cutscenes.`}<br parentName="p"></br>{`
`}{`First Cutscene, Gizel: "Well, they are slaves." `}<strong parentName="p">{`Option 2`}</strong>{`.`}</p>
    <p>{`Leave infirmary and go south twice, then go up stairs and watch cutscene, then go back downstairs and trigger another cutscene.`}</p>
    <p>{`Gizel: "Quite a festival in the streets, with the Sacred Games approaching." `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "town"
    }}>{`Town`}</h4>
    <p>{`Head south then east into alley for Shoon cutscene.`}<br parentName="p"></br>{`
`}{`Lyon: "I'm turning left at..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Shoon: "This isn't what it looks like!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go west to inn. After scene head back to Coliseum.`}<br parentName="p"></br>{`
`}{`Sialeeds: "Well, it's been a long trip, we're all tired, ..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Talk to Item Shop or Armor Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Sacrificial Jizo`}</li>
        <li parentName="ul">{`From bottom, everything above Breath of Ice S1 until Breath of Ice S3`}</li>
        <li parentName="ul">{`Hero: All Accessories`}</li>
        <li parentName="ul">{`Lyon: All Accessories (can skip Antitoxin)`}</li>
        <li parentName="ul">{`Georg: Everything`}</li>
        <li parentName="ul">{`Sialeeds: Everything`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Rune Shop (top left corner, closest to Arena Entrance)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Lightning Orb`}</li>
        <li parentName="ul">{`1 Breath of Ice S3`}</li>
        <li parentName="ul">{`1 Berserk Blow S3`}</li>
        <li parentName="ul">{`2 Dancing Flames S3`}</li>
      </ul>
      <h5 {...{
        "id": "equip"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Lightning > Hero`}</li>
      </ul>
    </Menu>
    <p>{`Head back to inn. Talk to Shoon, `}<strong parentName="p">{`Option 2`}</strong>{`.`}</p>
    <h4 {...{
      "id": "stormfist-sewers"
    }}>{`Stormfist Sewers`}</h4>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment--equip"
      }}>{`Equipment > Equip`}</h5>
      <ul>
        <li parentName="ul">{`Dancing Flames > Hero top slot`}</li>
        <li parentName="ul">{`Dancing Flames > Lyon 2nd slot`}</li>
        <li parentName="ul">{`Berserk Blow > Hero bottom slot`}</li>
        <li parentName="ul">{`Breath of Ice S3 > Lyon top slot`}</li>
        <li parentName="ul">{`Breath of Ice S3 > Hero 2nd slot`}</li>
        <li parentName="ul">{`Breath of Ice S1 > Sialeeds`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`This is kinda optional now`}</p>
        <h5 parentName="blockquote" {...{
          "id": "skills--equip"
        }}>{`Skills > Equip`}</h5>
        <ul parentName="blockquote">
          <li parentName="ul">{`Lyon & Prince: Magic top slot (ULU to select Magic)`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`This is for Speed for ambush rate, should be impossible to get ambushed with this setup.`}</p>
        <h5 parentName="blockquote" {...{
          "id": "swap-2"
        }}>{`Swap`}</h5>
        <ul parentName="blockquote">
          <li parentName="ul">{`Sialeeds > Entourage`}</li>
        </ul>
      </blockquote>
    </Menu>
    <ol>
      <li parentName="ol">{`East then left across bridge.`}</li>
      <li parentName="ol">{`Southwest across bridge then northeast across bridge.`}</li>
      <li parentName="ol">{`Southwest at save crystal then northwest and press button.`}</li>
      <li parentName="ol">{`Head back to save crystal, then go northwest.`}</li>
    </ol>
    <p>{`Gladiator: "They're coming from over that way..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go northwest to trigger cutscene.`}</p>
    <p>{`Suspicious Man: "Withdraw", Lyon: "Prince!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`After leaving Sewers, `}<strong parentName="p">{`before fight`}</strong>{`, swap Shoon for Sialeeds.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-3"
      }}>{`Swap`}</h5>
      <p>{`Shoon > Sialeeds`}</p>
    </Menu>
    <h4 {...{
      "id": "suspicious-men-250hp"
    }}>{`Suspicious Men 250HP`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Dancing Flames Center (1D)`}</li>
      <li parentName="ul">{`Lyon: Breath of Ice Scroll`}</li>
      <li parentName="ul">{`Georg: Defend`}</li>
      <li parentName="ul">{`Sialeeds: Defend`}</li>
    </ul>
    <h4 {...{
      "id": "prison"
    }}>{`Prison`}</h4>
    <p>{`Euram: "Neither Dad nor I knew anything about it!" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Leave prison.`}</p>
    <p>{`Back in your room, Lyon 1 textbox then `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`After Sialeeds: "Gizel...", 3m10s no input until dialogue choice.`}</p>
    <p>{`Lyon: "Just relax and take it easy." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Lyon (2 textboxes): "Oh, and Prince, you do know..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`After Lyon leaves your party go southeast (don't mash)`}</p>
    <p>{`Shoon: "I'm looking forward to this." Option 1`}</p>
    <h4 {...{
      "id": "shoon-duel"
    }}>{`Shoon Duel`}</h4>
    <p>{`Special vs Guard about same time.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Here comes another one, and this time`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Here I come!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I can't believe you turned my best...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I can't let you keep getting the...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm going to give it all I've got, be`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Not good enough, eh? Here I come again!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Now its my turn, I'll show you what...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You come at me too, Prince.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Lym: "No way! It's just not right! Brothers and sisters..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Royal Box. After Lym and Miakis leave party run southeast then southwest to your seat.`}</p>
    <p>{`Lym: "I know... But I have this cold feeling..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`3m15s before next dialogue option`}</p>
    </blockquote>
    <p>{`Ferid: "Seems very interesting...", "How about it? Would you like to meet him?" Option 1`}</p>
    <blockquote>
      <p parentName="blockquote">{`1m25s after dialogue option`}</p>
    </blockquote>
    <p>{`After Nikea scene, enter town and head northwest.`}</p>
    <p>{`Lyon: "That's awful!", "Prince!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "thug-x5-260hp"
    }}>{`Thug x5 260HP`}</h4>
    <ul>
      <li parentName="ul">{`Hero: Defend`}</li>
      <li parentName="ul">{`Lyon: Breath of Ice`}</li>
      <li parentName="ul">{`Georg: Defend`}</li>
      <li parentName="ul">{`Sialeeds: Breath of Ice`}</li>
    </ul>
    <p>{`Belcoot: "Thank you very much..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Run to inn.`}<br parentName="p"></br>{`
`}{`After Marina & Belcoot enter inn, Lyon: "What should we do?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Enter inn.`}</p>
    <p>{`Marina: "Silly Belcoot. What am I going to do with you?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Leave inn.`}</p>
    <p>{`Georg: "So... Whadja think?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Sialeeds: "What do you think? Do you think Belcoot..." Option 1`}</p>
    <p>{`Go back to Arena. 1m25s cutscene.`}<br parentName="p"></br>{`
`}{`Sialeeds: "Let's go break in on Belcoot and have a party!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Optionally, go to tutor and raise Prince & Lyon Magic to D`}</p>
    </blockquote>
    <p>{`Go to inn.`}<br parentName="p"></br>{`
`}{`Georg: "We don't have time to point fingers.", Belcoot: "I-I guess you're right..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Head southwest to next screen. Go southeast to last road then southwest to exit.`}</p>
    <h3 {...{
      "id": "world-map"
    }}>{`World Map`}</h3>
    <p>{`Southwest to Western Woods`}</p>
    <h3 {...{
      "id": "western-woods"
    }}>{`Western Woods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you fail an escape and kill an enemy via counter, make sure you retreat and don't bribe. If you bribe, you still get EXP for the killed enemy.`}</p>
    </blockquote>
    <p>{`Follow white dirt road, left at fork.`}</p>
    <p>{`Kick people out before Cabin.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-4"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Georg, Belcoot & Sialeeds to Entourage`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`1m40s after fade out before dialogue option. 1m5s after & 1m5s after fight.`}</p>
    </blockquote>
    <p>{`Dangerous Man: "How many times do you have to get in our way before you're satisfied?!" Option 1`}</p>
    <h4 {...{
      "id": "thug-x5-300hp"
    }}>{`Thug x5 300HP`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Dancing Flames Thug 2 (1D)`}</li>
      <li parentName="ul">{`Lyon: Breath of Ice`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Dancing Flames`}</li>
    </ul>
    <p>{`Leave Woods through main path in front of Cabin.`}</p>
    <h4 {...{
      "id": "inn"
    }}>{`Inn`}</h4>
    <p>{`Leave room.`}</p>
    <p>{`Marina (1st textbox): "Oh Prince..." Option 1`}<br parentName="p"></br>{`
`}{`Marina: "I should have thanked you earlier..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Run back to your bed.`}</p>
    <p>{`Leave inn, run back to Arena.`}</p>
    <p>{`Run to Royal Box.`}</p>
    <p>{`Lyon: "`}<em parentName="p">{`gasp`}</em>{` Belcoot!" Option 1`}</p>
    <p>{`Run to infirmary. 1m40s scene.`}<br parentName="p"></br>{`
`}{`After everyone leaves your party go to basement to talk to Zegai.`}</p>
    <p>{`Sialeeds: "Gizel, damn you... Damn you to hell!" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Zegai: "If death is my fate, then so be it." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go back to 2nd floor, 2nd door on the left to Queen's room.`}</p>
    <p>{`Arshtat: "But even if it is the truth...", Sialeeds: "Arshtat!" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Arshtat: "I'll do to Stormfist what I did to Lordlake!" Option 1`}</p>
    <p>{`Go back to Queen's Room, talk to Ferid twice. 2nd time 1 textbox then `}<strong parentName="p">{`Option 2`}</strong>{`.`}</p>
    <p>{`2m15s cutscenes.`}</p>
    <h3 {...{
      "id": "sol-falena-2"
    }}>{`Sol Falena`}</h3>
    <p>{`Lyon: "Oh Princess! Good morning." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Head to Audience Chamber.`}<br parentName="p"></br>{`
`}{`Georg: "Your Highness the Princess, Your Highness the Prince, ..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Sun Plaza, go east and take steps down. Then northeast across bridge.`}<br parentName="p"></br>{`
`}{`After bridge go directly southeast and across another bridge.`}<br parentName="p"></br>{`
`}{`Keep going southeast, east past the Appraisal shop, and take last bridge to exit Sol-Falena.`}</p>
    <h3 {...{
      "id": "world-map-1"
    }}>{`World Map`}</h3>
    <p>{`Head to East Palace.`}</p>
    <h3 {...{
      "id": "east-palace"
    }}>{`East Palace`}</h3>
    <p>{`Walk around main building to the back side.`}</p>
    <p>{`Miakis: "That's it?", Official: "Yes ma'am." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Zerase: "The Dawn Rune... Have you found it or not?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "world-map-2"
    }}>{`World Map`}</h3>
    <p>{`Head to Lunas. North east after exiting East Palace, go North as soon as you get east of the water. Move northwest around boulders along the way.`}</p>
    <h3 {...{
      "id": "lunas"
    }}>{`Lunas`}</h3>
    <p>{`Isato: "Allow me to introduce myself..." Option 1`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip-all-1"
      }}>{`Unequip All`}</h5>
      <ul>
        <li parentName="ul">{`Isato`}</li>
      </ul>
    </Menu>
    <p>{`Haswar: "Look how big you've gotten!" Option 1`}</p>
    <p>{`Go to bottom of Lunas and towards doors and watch cutscene.`}<br parentName="p"></br>{`
`}{`Isato: "I'm very sorry about that. Please pardon his lack of courtesy." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Head back to Oracle's Conclave.`}</p>
    <p>{`Lym: "Hero! No peeking!" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Sialeeds: "Cousin Haswar will be there, too. Are you really sure you don't want to take a peek? `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go towards Oracle's Conclave.`}</p>
    <p>{`Isato: "I'll go examine it. All of you, please head back and rest." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Lyon: "Do you think he'll be okay by himself?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Haswar: "What do you think we should do, Hero?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to 2nd floor then southwest most room.`}<br parentName="p"></br>{`
`}{`Lyon: "Prince, are you going to bed now?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "world-map-3"
    }}>{`World Map`}</h3>
    <p>{`Go to Raftfleet.`}<br parentName="p"></br>{`
`}{`Take same path back. When horizontal with East Palace head southeast, then south when aligned vertically on map.`}</p>
    <h3 {...{
      "id": "raftfleet"
    }}>{`Raftfleet`}</h3>
    <p>{`Go to Dahak meeting room`}<br parentName="p"></br>{`
`}{`Raja: "And you must be the famous Georg Prime, the one his..." Option 1`}</p>
    <p>{`Leave Raftfleet, head back to Sol-Falena.`}</p>
    <h3 {...{
      "id": "sol-falena-3"
    }}>{`Sol-Falena`}</h3>
    <p>{`Head back to Palace.`}<br parentName="p"></br>{`
`}{`Go to Audience Chamber, Inner Chamber, Arshtat's room.`}</p>
    <p>{`Before entering, Lyon: "Prince, I'll wait here." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Arshtat: "What did you think? They're nice people, aren't they?" Option 1`}<br parentName="p"></br>{`
`}{`1m15s cutscene after dialogue.`}</p>
    <p>{`Run up east stairs and go to your room (1st door)`}<br parentName="p"></br>{`
`}{`Maid: 1 Textbox `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "banquet"
    }}>{`Banquet`}</h4>
    <p>{`1m55s from Georg & Ferid to input.`}<br parentName="p"></br>{`
`}{`Lyon & Prince cutscene > load > instant textbox.`}<br parentName="p"></br>{`
`}{`Zoom in here for lag reduction.`}</p>
    <p><strong parentName="p">{`IMPORTANT`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-5"
      }}>{`Swap`}</h5>
      <p>{`Lyon & Sialeeds to Entourage`}</p>
    </Menu>
    <p>{`Talk to Ferid > 1 Textbox > `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`2m35s before fight.`}</p>
    <h4 {...{
      "id": "assassin-680hp"
    }}>{`Assassin 680HP`}</h4>
    <p>{`Hero: Berserk Blow x3 (2 Rune, 1 Scroll)`}</p>
    <p>{`Godwin Soldiers are ~900 each for bribe.`}</p>
    <h4 {...{
      "id": "dolph--childerich"
    }}>{`Dolph & Childerich`}</h4>
    <p>{`Auto`}</p>
    <p>{`Leave room. 1m30 from Sialeeds last textbox to dialogue option.`}</p>
    <p>{`Georg: "All you have to do is concentrate on getting the hell out of here!" Option 1`}<br parentName="p"></br>{`
`}{`(Right after) Georg: "Don't worry. She's all right..." Option 1`}</p>
    <p>{`After Georg and Zegai join party, 1m55s no input.`}</p>
    <h3 {...{
      "id": "east-palace-1"
    }}>{`East Palace`}</h3>
    <p>{`Textboxes after cutscene, before control.`}</p>
    <h3 {...{
      "id": "world-map-4"
    }}>{`World Map`}</h3>
    <p>{`Head to Lunas.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you swapped Lyon & Sialeeds out, they don't auto rejoin here.`}</p>
    </blockquote>
    <h3 {...{
      "id": "lunas-1"
    }}>{`Lunas`}</h3>
    <p>{`Textboxes instantly on entry. Run to Oracle's Conclave.`}<br parentName="p"></br>{`
`}{`Haswar: "I'll get a meal ready for you all, but you'd better rest..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go upstairs, bottom-left room. 1 Textbox then Option 1. 1m38s before textboxes.`}</p>
    <p>{`Gizel: "Don't worry, we know where they are. It won't be hard to catch them." then 1m35s no input." Regain control after loading screen.`}</p>
    <p>{`Go downstairs, first room on right.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If swapped out, Sialeeds & Lyon rejoin here.`}</p>
    </blockquote>
    <p>{`Head to woods. Follow path.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Need to press X and hold up/down to use ladders.`}</p>
    </blockquote>
    <h3 {...{
      "id": "world-map-5"
    }}>{`World Map`}</h3>
    <p>{`Head southwest to Haud, entrance is on left side.`}</p>
    <h3 {...{
      "id": "haud"
    }}>{`Haud`}</h3>
    <p>{`Head east to bridge.`}</p>
    <p>{`Zegai: "If I'm with you, you won't be welcome there." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`North and talk to Boz by stairs, `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><strong parentName="p">{`TRIANGLE TO SKIP BOAT ON WORLD MAP`}</strong></p>
    <h3 {...{
      "id": "rainwall"
    }}>{`Rainwall`}</h3>
    <p>{`Run to Barow's Manse.`}<br parentName="p"></br>{`
`}{`Go to 2nd floor bottom right room. 2m35s after Luserina last textbox.`}</p>
    <p>{`Lyon: "Prince, do you think you can still trust me..." Option 1`}</p>
    <p>{`Go to 1st floor.`}</p>
    <h4 {...{
      "id": "war-battle-first-battle"
    }}>{`War Battle: First Battle`}</h4>
    <p>{`No setup.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d4b76df3d4b94295bd03a020d678076f/6af66/FirstBattle.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADzElEQVQ4yx2T20+TZxzH379kyZLd7G7Jkm2JN5rMZMgwHpcgyEBFEbS1pe3b0hZ6oAU5FKktp1pK6fl9ewJ6oBQ5bAqbwbnFzbiLGdw0W6LZxbLsYOI+e7arJ3mS3+/5Hj6PFE1qGZ8y4A3o8Iw3c777IB1dh5CtTeh6D2OxNuAaa0YtT7F3f5vPPl/lzk6d7bt14vkQ/pkeZqMGZhZk5hU9UiRtpkUfpKV3kuveTlyW41w8+wEtp97hyOE3OP3J25i8/y0M4HacoE9uFedVnI4rDLq1hIIyayWFWnmFlVUPkt51Cq29mZm4gUSul8lAJ5qrR/5XOzfRStR5htycTLHmZlz+EOu593A5mrFbzuBx92DWNHC57X2udBwgNN+J5J/VMh82U1SGyKlulJSTQmGYct5PIddPWRmhHgqQTQwSH+sgKDegNb7LkPkjlFE9wyNajjW+xdGGNzFYG5GqyjSlZIBCdJJ8zEcxOcHq8jQr2Snyyg1u12PUViLEFs3Eo+LxQLdQdpLg5DnU+BjlcpJk0s/5Cwf49PJBpFxsiuC4jczcCGp4nKX0DW7dtJIOualnfUSCNmYDAyQzVmJLBtRVG7U7IygVO9/u7/HnP/D769csbyeZTVxBmr/lx9LbzYLfTSkTpFqaYtpn5JbxAj7NMa6ZGvHNX0St9pOvO8nV7MSXLFwS1rObCi9e/c3Lv17xcP8e+TU70p1vdslGJ0RGXoqpcZGlj0pumnjQyFzqGvGKjcKmi6UNF9l1J+GckR5bEwZvF3vPnvDdry958PP3VHb8ZG+7kdTqKKmUlUy6n0xRRi3ZUJcmSNWuk90YIL/lYaFoYTR8iZsRGZtXQ5fcSHozx+6zH/ni6Q/U7kVQ12xkhQMpFO9mUeCSWDKRqTlY3rRT2TRTVU2UYwa2tnwkFDOTwbNMDJ4S6JxkIa2l+vU6q48fcfvxA1a2hlBWzSKWIaRYQWYhZyBaMIls+gRvMpUNE8WVPkolJ4uqjljaSCpsIhHuIRHViMFBNh99ye7+E756/hPLOzFCyW4U0YGULvUJRR5Kwn+mLJMVLS5vDFK9O0JRZFfcEKrr/aQTHmIZC8XtfuKLYmY9xtM/fuP+L8+5/+KZaL5IqRhGms3oGZhowzd3meC8RvxLHcmsk0zBy0xEz2xch2/0NHbNx4wNtzMT7cIjH8VhPU4kf5PkeoXl3R3SaorMWk5wGNBww9yMUd/EifaDnG4/xMVrTdi9bdiHW9H3n8DgOI7O3iIKaccx2i7u2xgY7sB1vRWds4XJOcFq1MfGwz3+BQaU/ddWcuCVAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "First Battle",
            "title": "First Battle",
            "src": "/static/d4b76df3d4b94295bd03a020d678076f/6af66/FirstBattle.png",
            "srcSet": ["/static/d4b76df3d4b94295bd03a020d678076f/8ff5a/FirstBattle.png 240w", "/static/d4b76df3d4b94295bd03a020d678076f/e85cb/FirstBattle.png 480w", "/static/d4b76df3d4b94295bd03a020d678076f/6af66/FirstBattle.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Boz`}</strong>{`: Move to P1`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: Press R1 to select, move to P1`}</li>
      <li parentName="ol"><strong parentName="li">{`Boz`}</strong>{`: Once slightly above left tree (as pictured), move to P2`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: When middle soldier turns southeast, target him. Should be right before Boz kills Archer.`}</li>
      <li parentName="ol"><strong parentName="li">{`Boz`}</strong>{`: After killing Archer, target middle unit.`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: After fighting middle unit, move 1 tile above bush in southwest corner.`}</li>
      <li parentName="ol"><strong parentName="li">{`Boz`}</strong>{`: After killing middle unit, target southwest unit.`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: When he is about 1/2 a tile below last unit, move prince directly up. Should attack and push unit to Boz.`}</li>
    </ol>
    <p>{`After results screen 2m25s no input.`}</p>
    <h3 {...{
      "id": "rainwall-1"
    }}>{`Rainwall`}</h3>
    <p>{`1st floor, 1m25s no input`}</p>
    <p>{`Go to inn 2nd floor, pick up `}<strong parentName="p">{`Prosperity Ring`}</strong>{`.`}</p>
    <p>{`Exit town.`}</p>
    <h3 {...{
      "id": "world-map-6"
    }}>{`World Map`}</h3>
    <p>{`Head to Raftfleet. Can run southwest along the river.`}</p>
    <h3 {...{
      "id": "raftfleet-1"
    }}>{`Raftfleet`}</h3>
    <p>{`Go to Dahak for cutscene, then to Logg's boat.`}<br parentName="p"></br>{`
`}{`Logg: "Please! A-A-All right. Please sir!", Lyon: "Prince..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`If you want a safer Cius & Lelei, you can pick the Jizo by the Rune Shop.`}</p>
    </blockquote>
    <p>{`Talk to Logg 1 Textbox, `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After Option 2 55s then instant textboxes in Wharf.`}<br parentName="p"></br>{`
`}{`Leave Wharf.`}</p>
    <h3 {...{
      "id": "world-map-7"
    }}>{`World Map`}</h3>
    <p>{`Head to Lordlake. Go east till you can go south, then southeast (slightly more south than east)`}</p>
    <h3 {...{
      "id": "lordlake-1"
    }}>{`Lordlake`}</h3>
    <p>{`Talk to Talgeyl by entrance.`}<br parentName="p"></br>{`
`}{`Leave Lordlake & head to Rainwall.`}</p>
    <h3 {...{
      "id": "wharf"
    }}>{`Wharf`}</h3>
    <p>{`Logg: "Ya could try goin' back an' then comin' again later..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "raftfleet-2"
    }}>{`Raftfleet`}</h3>
    <p>{`Don't over mash when Lun leaves party, can talk to Logg again accidentaly.`}</p>
    <h3 {...{
      "id": "rainwall-2"
    }}>{`Rainwall`}</h3>
    <p>{`Go to Salum's Manse, talk to Salum.`}<br parentName="p"></br>{`
`}{`Go to your room.`}</p>
    <p>{`If you haven't already,  floor, pick up `}<strong parentName="p">{`Prosperity Ring`}</strong>{`.`}</p>
    <p>{`Leave town, go to Raftfleet.`}</p>
    <h3 {...{
      "id": "raftfleet-3"
    }}>{`Raftfleet`}</h3>
    <p>{`Talk to Logg, 1 textbox then `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`After load `}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong><br parentName="p"></br>{`
`}{`After cutscene > conversation > load `}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong>{`.`}</p>
    <h3 {...{
      "id": "baska-mines"
    }}>{`Baska Mines`}</h3>
    <Menu mdxType="Menu">
      <p>{`This prevents ambushes in mines before Gunde joins/after Gunde leaves.`}</p>
      <h5 {...{
        "id": "swap-6"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Logg: Entourage`}</li>
        <li parentName="ul">{`Lun: Entourage`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Optional: Pick `}<strong parentName="p">{`Turtle Orb`}</strong>{`, chest closest to Beaver.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mine-shaft"
    }}>{`Mine Shaft`}</h4>
    <ol>
      <li parentName="ol">{`East 1st Fork at entrance`}</li>
      <li parentName="ol">{`North fork with cart.`}</li>
      <li parentName="ol">{`East all the way and follow path.`}</li>
      <li parentName="ol">{`Push next cart and follow cart.`}</li>
      <li parentName="ol">{`South at fork then west at next fork.`}</li>
    </ol>
    <h3 {...{
      "id": "dwarf-camp"
    }}>{`Dwarf Camp`}</h3>
    <p><strong parentName="p">{`Buy Jizos`}</strong>{`. Can buy up to 3, need to have 900 left after purchases.`}<br parentName="p"></br>{`
`}{`Go northwest.`}</p>
    <h3 {...{
      "id": "tunnel-to-agate"
    }}>{`Tunnel to Agate`}</h3>
    <ol>
      <li parentName="ol">{`Go straight until you reach open area.`}</li>
      <li parentName="ol">{`Go northwest in open area.`}</li>
      <li parentName="ol">{`Right at fork.`}</li>
      <li parentName="ol">{`Northwest at fork.`}</li>
      <li parentName="ol">{`North at fork.`}</li>
    </ol>
    <h3 {...{
      "id": "agate-prison"
    }}>{`Agate Prison`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Military Uniform`}</strong>{` and `}<strong parentName="p">{`Guard Ring`}</strong>{` on the way to Lucretia.`}<br parentName="p"></br>{`
`}{`Do this menu before 3rd torch on wall after open cell door on screen with Lelei & Cius.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-1"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Sacrificial Jizo: Hero`}</li>
        <li parentName="ul">{`Guard Ring: Lyon`}</li>
        <li parentName="ul">{`Military Uniform: Lyon`}</li>
        <li parentName="ul">{`Knight Full Armor: Logg`}</li>
        <li parentName="ul">{`2 Sacrificial Jizo: Lyon`}</li>
        <li parentName="ul">{`Prosperity Ring: Hero`}</li>
      </ul>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Sort`}</li>
        <li parentName="ul">{`Heal Hero, Lyon, Logg`}</li>
      </ul>
      <h5 {...{
        "id": "swap-7"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Lun: Party (This needs to be done first! Want Logg in backrow)`}</li>
        <li parentName="ul">{`Logg: Party`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "prison-guards"
    }}>{`Prison Guards`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Guards are in this order: Cius 500HP, Sword 400HP, Crossbow 400HP, Lelei 500HP`}<br parentName="p"></br>{`
`}{`Don't kill crossbow until he kills Logg T2.`}<br parentName="p"></br>{`
`}{`Lun and Logg must die, Hero and Lyon must live.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Breath of Ice Scroll`}</li>
      <li parentName="ul">{`Lyon: Dancing Flames Scroll Cius (1)`}</li>
      <li parentName="ul">{`Lun: Defend`}</li>
      <li parentName="ul">{`Logg: Grilled Salmon Hero`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Breath of Ice Scroll`}</li>
      <li parentName="ul">{`Lyon: Dancing Flames Scroll Cius (1)`}</li>
      <li parentName="ul">{`Logg: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Berserk Blow Lelei / Breath of Ice Scroll if Cius lived`}</li>
      <li parentName="ul">{`Lyon: Dancing Flames Lelei`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Auto / Spell to finish Crossbow or adjust to whatever happened.`}</li>
    </ul>
    <p>{`Lucretia: "So with that understood... Do you still want me to be your tactician?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip-all-2"
      }}>{`Unequip All`}</h5>
      <ul>
        <li parentName="ul">{`Lun`}</li>
        <li parentName="ul">{`Logg`}</li>
        <li parentName="ul">{`Cius`}</li>
        <li parentName="ul">{`Lelei`}</li>
      </ul>
      <h5 {...{
        "id": "unequip"
      }}>{`Unequip`}</h5>
      <ul>
        <li parentName="ul">{`Hero: Jizos`}</li>
        <li parentName="ul">{`Lyon: Jizos, Guard Ring`}</li>
      </ul>
    </Menu>
    <p>{`Exit through front door.`}</p>
    <p>{`On boat, Lucretia: "Prince, let's hurry to Raftfleet." > Load > `}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong></p>
    <h3 {...{
      "id": "raftfleet-4"
    }}>{`Raftfleet`}</h3>
    <p>{`Go to Dahak.`}<br parentName="p"></br>{`
`}{`Lucretia: "Yes, good point.", "Prince, what would you like to do?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-intercepting-lugers-fleet"
    }}>{`War Battle: Intercepting Luger's Fleet`}</h4>
    <p>{`No Setup`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/869d1047529d89c23e9e8578cb1bd293/6af66/InterceptingLugersFleet.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADv0lEQVQ4yx2U6U/aWRiFf/9Zk8mMnTa1rUtdRqRapWhRUXBBkCoCiiKL4K6ICAKKgBYsFpeq49Ial4zjEm0nnbRTZ0vmX3jmph/Ol5ub897znDdXMqV92EMenAEnzpkuLFNdNE5YUUzZkXlNyMetyJIzyBIzlLr1FFibKPN0UjVuo2Z6AM2kmVavA4PbTWR7FkkZHqdE7aFA7aLe0kyFrpJ8VR7lmlLyFA8oa/2Jmsw8ivQcpc3F5FbkkCvPQaYqpLq5HK21HqPOTVdzANNKBKnmVRBlaAy5f5Byfy9FE508HGon19NK0XgnlUE7L1ajKN8soGrJp77qjjDK50nlHcpUj3imLaaqUYairghtyIWkWo1RtuSjIDHK94EeckL93A07uRd1USxw1G4toVqLIU8FsdnV9BoKKdR8h6zhrkhTQa1JhbKjmue6cizpaSTd7irarVdUvvKTH3ZwP9jLvWAfhfFhnqb8VK0EqU+H0YenmOvWMOxqo7K3hSq7DrXXSI9I0D/vwTJjw7G/jDT88QTf72c4zg9oWI9RmhzjUdRJXsRF5fKMUICa1QgdEz5aeoy0j/XRdbBG/V4G9U4ax+k2EzsJfBd7OC4OkFb++0T0+j1Wvx1tbIq6tUWUmRBPBQalKEL7Jo41FmNoK8vA2T6dhxsYkiHM00PULwn+AlmduKfJLtIm8EgLf90wdrqJc20B6+E6HQKBanWe2kyUpvUkxmQQ+/Iywye7DG9EGDz/mf5sAsd84Nsw7cYSLdtplGsJqsU2SM53WfQLPrpSYSzJWWrH3VSHJtG8TaFIzaF4HaVqM47paJPp7Bz+4zUGPxzhujrE9G6D9p0Mxveb6A83UW+lkcziFQ0jfdQNDfDMaSHvpZYn3j5U6wleZOPfDDW7r/HeHBG4vSb69YpZwXzxyyWjwtSwn6VhZwW9MDcKtlJdYpbngz3IBoSZRcd9g5oHLjONovnm3Td0iATuy30Cn38l8uWC8B+XRIXZwucLJj8eYzt9i/XkLZM3x7jPd5HkcxM8NuvI73nJg24due1qSr02mvYzNO2t4r4+IvHnFbG/r4n/+5HFfz4Qvr0ienuJ7/MvjH06Jfj14pumfjtGehoc5Yc2NTn6Ju4aW8nraOVhdxsFI/08FlLMjqJb9KOPBbGsLGBemacl7se4HMImmjWkIrwUZ6ZMjLGzPaQKsXM/9jSS5zBSMmih1GOh0GXisc1Iob2bggEzJR4bJQO9KCe9lI3YkY86xOfhoSU8SUNwAl3UT39qHsdBlv8Btxn58Gw5ek8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Intercepting Luger's Fleet",
            "title": "Intercepting Luger's Fleet",
            "src": "/static/869d1047529d89c23e9e8578cb1bd293/6af66/InterceptingLugersFleet.png",
            "srcSet": ["/static/869d1047529d89c23e9e8578cb1bd293/8ff5a/InterceptingLugersFleet.png 240w", "/static/869d1047529d89c23e9e8578cb1bd293/e85cb/InterceptingLugersFleet.png 480w", "/static/869d1047529d89c23e9e8578cb1bd293/6af66/InterceptingLugersFleet.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`All actions are done with Baz (directly above Dahak)`}</p>
    <ol>
      <li parentName="ol">{`Move to P1`}</li>
      <li parentName="ol">{`Right before you reach P1, move to P2 (P2 is 2L2U from P1)`}</li>
      <li parentName="ol">{`Right before / when the square in Boz's ship & Luger's ship's front sail are vertically aligned, move to P3. Refer to blue crosshairs in image for visual cues.`}</li>
      <li parentName="ol">{`If done correctly, Luger won't have moved & Boz will automatically attack him again. If not, manually move to Luger's ship.`}</li>
    </ol>
    <h3 {...{
      "id": "raftfleet-5"
    }}>{`Raftfleet`}</h3>
    <p>{`Exit town, automatically back to Rainwall.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Autohealed somewhere beteen Agate and now.`}</p>
    </blockquote>
    <h3 {...{
      "id": "rainwall-3"
    }}>{`Rainwall`}</h3>
    <p>{`Go to Salum's Manse. Go to your room.`}<br parentName="p"></br>{`
`}{`Go to Oboro's ship.`}</p>
    <p>{`Sagiri: "Your Highness.", "Our boss is out of the office at the moment..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to town exit, trigger `}<em parentName="p">{`leave town`}</em>{` prompt, `}<strong parentName="p">{`do not leave!`}</strong><br parentName="p"></br>{`
`}{`This triggers Oboro, go back to his boat.`}</p>
    <p>{`Back to Barow's Manse.`}<br parentName="p"></br>{`
`}{`Go to your room, Lyon 1 textbox then `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Salum all Option 1. When Lyon joins your party stop mashing so you don't accidently talk to her.`}</p>
    <p>{`Go downstairs, talk to Salum & Lucretia. Then go back to your room.`}</p>
    <p>{`Go back downstairs, 1m10s cutscene before option.`}<br parentName="p"></br>{`
`}{`Salum: "I think it might finally be time to give the order to go into battle..." Option 1`}</p>
    <h4 {...{
      "id": "war-battle-rainwall-defense-campaign"
    }}>{`War Battle: Rainwall Defense Campaign`}</h4>
    <h5 {...{
      "id": "setup"
    }}>{`Setup`}</h5>
    <ul>
      <li parentName="ul">{`Sialeeds: Remove Sialeeds, Lelei. Add Kisara (1D), Lelei (X), Luserina (1D)`}</li>
    </ul>
    <p>{`Kisara's unit is 2 left from Hero's`}</p>
    <h5 {...{
      "id": "strategy"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a61ed2bff2f454468bfae16c9f988e0b/6af66/RainwallDefenseCampaign.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADHUlEQVQozxXQyXLbBACAYT1MYVhSkky8JHLsSrJWS7a1uJJsyVptWYtlWd7XxKG2mYQmlJamFDoJDAwcOmzDoQMHTnCAB2DgbSgv8M83P3D2oeKNtJovq01o+oA/uZBG73PhhO7MyNVn89//+fu3P3758dXLj59sJmPPtoV2oNzcPN1sl0FsAE9uQ7X/VO1/dLrS4w7p2KDrZMqFOzXx7va2+9e/fz6+HNo1ROezhgiNQ2kxMH7+/ptfX/10c3sJfPGy58acHpa9PqO7ed2Hg0nBaqNGJ79+Fs3Pxw+aSMTccR1CLu9J5eSgVWybRFvPLxYu8NUPwy+/65l9ujlha2HB6DGNcUnvMe5C3D5a2R1zbtHXA+Hqg+pFK3umw/2OWKETNS69Om0Dswtl81hXfdwdMVaXak8YK6bqHcoZFP2R5PT0zUlwteo+X4+meuEkktanbujykcdfP9sCjSFj9gvBohQuWc3NNwYFM6YaXdKJcH9AKQ5lx1Izrrs9z+40+rPw+tPLr799sT5ffvL8EfDw86a/5JxZOVhySpvUI0rvkGID1gJcaeWrfl5086KDSTYznPfmZ6N45q4fzrsj53Q9A65e2J1lUQ1xycVbU1YJSaPP/F+JKXdZCxaG1WdH2/pgUe1O70dTTrQg2cHNuOiOBSBasKIFQ9zxcWEfovaK0mG+lKh6eD2mZi1zcz7xZlKwrJivRSGmuYhsQ/cbiDVgnGkJoOTMWwdvZMgEUjzIoXdB+B1GTFbMnGDhvUg2vSKngVqAqR5qxmQwY7QQV9u47GKcCQG0DOJsmuIPSeGIYlMIvFOqpKwQoypp1cMMH7N9TNKylo/6Q0pxkdaQkhyYkEDNwwDZvIeXkoVKiuCTFJdEqD2ST+oRjgkpVskYHtrsEPUWXLPuaU247iN2hJohVnt9Uc8BBT4NE7tZ9N0j6G2c2YfpXZw9UByIkdOkkEznD2A6zVePFQMimCSIvEcKIFMBWfGY5lIASu9n0B2Y2c9RuwSfKFUPORUkuMQRurMPvokzGYIBS0JWkCGYOCyUMnQVYSVI1TGpnvsPHvk4lIL+c3EAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Rainwall Defense Campaign",
            "title": "Rainwall Defense Campaign",
            "src": "/static/a61ed2bff2f454468bfae16c9f988e0b/6af66/RainwallDefenseCampaign.png",
            "srcSet": ["/static/a61ed2bff2f454468bfae16c9f988e0b/8ff5a/RainwallDefenseCampaign.png 240w", "/static/a61ed2bff2f454468bfae16c9f988e0b/e85cb/RainwallDefenseCampaign.png 480w", "/static/a61ed2bff2f454468bfae16c9f988e0b/6af66/RainwallDefenseCampaign.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move Kisara to spot in image. Doesn't need to be precise.`}</li>
      <li parentName="ol">{`Barrage Jiden 2-3 times.`}</li>
    </ol>
    <h3 {...{
      "id": "rainwall-4"
    }}>{`Rainwall`}</h3>
    <p>{`Go to Store Room.`}<br parentName="p"></br>{`
`}{`Chuck: "If you guys wanna go down there, you'll have to get through me!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "chuck-duel"
    }}>{`Chuck Duel`}</h4>
    <p>{`Special vs Special is 5s faster than Guard vs Special`}<br parentName="p"></br>{`
`}{`So if he's not guarding, Special.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I don't like picking on the weak.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I...I need a little break here...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`If you won't come at me, I'll go...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm really gonna pound you, so get...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`No Way!! You haven't seen the last...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`That was nothing, but you're really...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`This one's for the young lady!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well, c'mon then!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defend`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Go to basement > wardrobe. 1m50s cutscene, can move instantly afterwards. Run southwest, exit storeroom.`}</p>
    <p>{`Exit town, run to Raftfleet.`}</p>
    <h3 {...{
      "id": "raftfleet-6"
    }}>{`Raftfleet`}</h3>
    <p>{`Go to Dahak meeting room.`}</p>
    <p>{`Raja: "Well, Your Highness, what should our next course of action be?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Lucretia: "What do you think, Your Highness?" `}<strong parentName="p">{`Name Army`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`X Start Xx3 is fastest`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`From now on, zoom in near Raftfleet entrance for lag reduction.`}</p>
    </blockquote>
    <p>{`Go to exit Raftfleet, Dragonhorse cutscene 1m55s before dialogue.`}</p>
    <p>{`Rahal: "Come on Roog, we're leaving." Option 1`}</p>
    <p>{`Exit Raftfleet.`}</p>
    <h3 {...{
      "id": "world-map-8"
    }}>{`World Map`}</h3>
    <p>{`Head to Lordlake, same path as before.`}</p>
    <h3 {...{
      "id": "lordlake-2"
    }}>{`Lordlake`}</h3>
    <p>{`Talk to Talgeyl. Go to Clinic. Leave Clinic.`}</p>
    <p>{`Toma: "Of COURSE that's what I'm saying! How am I..." Option 1`}<br parentName="p"></br>{`
`}{`Run back to Raftfleet.`}</p>
    <h3 {...{
      "id": "raftfleet-7"
    }}>{`Raftfleet`}</h3>
    <p>{`Before meeting room, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Kyle: Party`}</li>
      </ul>
    </Menu>
    <p>{`Dahak meeting room. After cutscene `}<strong parentName="p">{`talk to Raja or Lucretia to unlock Yashuna.`}</strong></p>
    <p>{`Go towards Rune Shop, pick up 2 chests straight below Rune Shop for `}<strong parentName="p">{`Sacrificial Jizo`}</strong>{` & `}<strong parentName="p">{`Mega Medicine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Lightning Orb`}</li>
      </ul>
      <h5 {...{
        "id": "attach"
      }}>{`Attach`}</h5>
      <ul>
        <li parentName="ul">{`Lightning: Lyon`}</li>
        <li parentName="ul">{`Lightning: Kyle RH, over Water Rune`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Logg, go to `}<strong parentName="p">{`Yashuna Village (2D)`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong></p>
    <h3 {...{
      "id": "yashuna-village"
    }}>{`Yashuna Village`}</h3>
    <p>{`Head southwest from boat to pick up `}<strong parentName="p">{`Arrow Stance`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Back west across stairs then across south stairs and go straight to exit.`}</p>
    <h3 {...{
      "id": "world-map-9"
    }}>{`World Map`}</h3>
    <p>{`First battle you get, switch to Arrow Stance.`}<br parentName="p"></br>{`
`}{`Head Southeast then south `}<strong parentName="p">{`on road`}</strong>{` to Mountain Path.`}</p>
    <h3 {...{
      "id": "mountain-path"
    }}>{`Mountain Path`}</h3>
    <p>{`Straightforward. On 2nd screen southwest near start.`}</p>
    <h3 {...{
      "id": "world-map-10"
    }}>{`World Map`}</h3>
    <p>{`West along hill, slighly southwest at end.`}</p>
    <h3 {...{
      "id": "beaver-lodge"
    }}>{`Beaver Lodge`}</h3>
    <p>{`Go to Chief's house. 2m30s no input after Toma textbox.`}<br parentName="p"></br>{`
`}{`Leave Chief's house. After cutscene head east to exit.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-2"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`All Best: Kyle`}</li>
      </ul>
      <h5 {...{
        "id": "swap-8"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Maroon: Entourage`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "world-map--mountain-path--world-map"
    }}>{`World Map > Mountain Path > World Map`}</h3>
    <p>{`North until you pass tree on left by road then northwest.`}<br parentName="p"></br>{`
`}{`Once you get past hill west, slightly south. Keep going west till you pass top of lake below you, then southwest and south.`}</p>
    <h3 {...{
      "id": "ceras-lake-ruins"
    }}>{`Ceras Lake Ruins`}</h3>
    <p>{`Zweig: "First things first, show me the Dawn rune." Option 1`}<br parentName="p"></br>{`
`}{`Lyon: "Prince, let me take care of this." Option 1`}</p>
    <h4 {...{
      "id": "lorelai-duel"
    }}>{`Lorelai Duel`}</h4>
    <p>{`Special vs Special is .8s faster than Guard.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't let that swell your head, I'm...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hey, aren't you a little too far...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hey, you'll pay for tht! Here comes...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmm...I guess I'll just warm up a...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I can see right through your moves...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I guess I'll settle this thing right...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm still fine, I can still fight!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Not bad, but wait 'til you feel this!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Unh... you're stronger then I thought!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`What are you doing? I'm not letting...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`What did you do, give up? You gotta...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`What do you think you have to hold...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You still standing? I'll hit you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You underestimate me...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "left-side"
    }}>{`Left Side`}</h4>
    <ol>
      <li parentName="ol">{`North at fork`}</li>
      <li parentName="ol">{`North at fork, press switch.`}</li>
      <li parentName="ol">{`Back to 1st fork, go south this time and go to next screen.`}</li>
      <li parentName="ol">{`North at fork, press switch.`}</li>
      <li parentName="ol">{`Back to fork, west all the way. Press big switch in next room and backtrack to start (all the way east).`}</li>
    </ol>
    <h4 {...{
      "id": "right-side"
    }}>{`Right Side`}</h4>
    <ol>
      <li parentName="ol">{`South at fork`}</li>
      <li parentName="ol">{`North at fork.`}</li>
      <li parentName="ol">{`North at fork, press switch.`}</li>
      <li parentName="ol">{`Backtrack to #1, go east this time.`}</li>
      <li parentName="ol">{`Gotta go both ways here to hit switch, doesn't matter which is first.`}</li>
      <li parentName="ol">{`Back to #3, east this time. Go to next screen.`}</li>
      <li parentName="ol">{`North at fork, press big switch.`}</li>
      <li parentName="ol">{`Backtrack to main room.`}</li>
    </ol>
    <p>{`Cutscene 1m15 no input.`}<br parentName="p"></br>{`
`}{`Do this menu on Suns screen after cutscene (screen after savepoint.)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Heal party with Mega Medicines`}</li>
      </ul>
      <h5 {...{
        "id": "equip-3"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Jizos onto Hero (Over Berserk Blow Scroll), Kyle, Lyon in that order if short)`}</li>
        <li parentName="ul">{`Berserk Blow Scroll: Zweig`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "diamond-sun-a-3900hp--diamond-sun-b-4500hp"
    }}>{`Diamond Sun A (3900HP) & Diamond Sun B (4500HP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Can 3T kill with normal MP and 2 Berserk Blow Scrolls for Zweig.`}<br parentName="p"></br>{`
`}{`T1 is standard, if no stun then Hero & Zweig Berserk Blow Sun `}<strong parentName="p">{`B`}</strong>{`, rest standard.`}<br parentName="p"></br>{`
`}{`T3 All use best remaining Magic, should barely kill.`}</p>
    </blockquote>
    <p>{`All target Sun A till dead`}</p>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero: Soaring Bolt`}</li>
      <li parentName="ul">{`Lyon: Soaring Bolt`}</li>
      <li parentName="ul">{`Kyle: Furious Blow`}</li>
      <li parentName="ul">{`Zweig: Berserk Blow / Dancing Flames Scroll`}</li>
      <li parentName="ul">{`Lorelai: Soaring Bolt`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2--on"
    }}>{`Turn 2 & on`}</h5>
    <p>{`All use best magic`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip-1"
      }}>{`Unequip`}</h5>
      <p>{`All Jizos. Can leave one on Kyle for Zahhak later.`}</p>
    </Menu>
    <p>{`Go to Dawn room, run out after cutscene.`}</p>
    <p>{`Viki: "It must be fate, us running into each other like this. Would you mind watching over me?" Option 1 (1m10s before dialogue).`}</p>
    <h3 {...{
      "id": "raftfleet-8"
    }}>{`Raftfleet`}</h3>
    <p>{`Dahak meeting room.`}</p>
    <p>{`Lucretia: "So Prince, what do you think of the plan?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Lucretia: "Just give the word Prince, and we'll get started right away." `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-hatred-fortress-siege"
    }}>{`War Battle: Hatred Fortress Siege`}</h4>
    <h5 {...{
      "id": "setup-1"
    }}>{`Setup`}</h5>
    <p>{`No Setup`}</p>
    <h5 {...{
      "id": "strategy-1"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/705785abf7fb9feac42232cf3f07087d/6af66/HatredFortressSiege.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADlElEQVQ4yx2S21OaVxTFv3+qr5l0mulDb0k1Gq8o6PchAbmIchMIAfEGKiKKEhDkpshFBURQMVo1rdOHdtI/6NdjHvacc2bvvc5eay/J2SqxkI0SPQgQSfuxZjdYPE0ROPmEJRNGs7eA7vyI6XaZkZiXoXUHwxEH41seDMlVVFEfcmwOJWZDXYgjfTjJMGzaYsgqgJb02NwTKE416rlRhnS/o/NqsF7VsN82kL1q+qdeMzrdz4DImT0KWqfC2th3RJVeBmJBpPT1Lls5I7H8e9LVJTylbYzFbWzHeyzW8wSbecydKu7HSxy+MXTyS2T7W7SzvajM/Wgs75iY+pVJ5Sd06VWkQstAsa0hf2nj5D7H2m0NQ7eO4bKK4eqEwF+fMXYqmLpnfAzbiAQV/MuDOIzfs+boRxaM3hjeMTIzgLuaEBM27WSbejJNM7l2imD7SGhWQtvIM1rdR67nmBGUJy8KBApRDkq7JPObLIVMhMIGrBEn0xturJvzeM/zSNXuDkedeXKtEIlWBtdNXSyggtwsMPEcjSKzrQKuDSuTzSLyZQXzVYWPD+csPXWJ/PPI5r9fcN+3sYpeqdBNUb6NUbzOsH51hPPuAuv1KQax1ecCrWheqZTx18vYC3vYSimmTnOYW8e4PjeZEfpahDSzNw30okdaeWxz+FAm1vzEvPj9OeEQhc7bc2ziPvdHi0DjDO91A0/jiNlaDv1JDm0pyUQ5haqSYvw0y6RYoLZ5iDRdyyNHFhhc8TAQ8iOvBRkWp5KMsfz0GdddC9tdE7+g5O02sHdqGIV3dbUD5GoaVTmJuppCPj9EJSwoaYtJfnRaRJh565tFtehhNOhCu7UidLrCLQDdQobw33cs3newiylN1QMxZRaToKsW000sWpFTIcYvSkhj2TivnCZ+8c3RG3Dwm9/FG79XOH8Vx03zG+15Aep/Bhdve6uM5TSPInRUqhnGj/bQFOMolX1GBLg0UysIACc9C256AjZ+9lh4ZdbSs+T5pp/5to7rzw7LXx9Y/fqFyH9PBB87OA/jGATdqWMRnTKTwlpjQkdpTgD2+ZwMLnj5wW7ihV5FX/9LXpgUehLrDCY2sIlFBOolAi1h8OMDdPkkGocOldvE4M4a44lNhrdDDBV2kSxnRUaiKyiJLXrCHxhetdHnNzFiVlC0Gl4ve9GmYujjUeaKKZylfYy5BHI6jry7LnrDGHYizKR2eO8z8z9xmuRYsLJlWgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Hatred Fortress Siege",
            "title": "Hatred Fortress Siege",
            "src": "/static/705785abf7fb9feac42232cf3f07087d/6af66/HatredFortressSiege.png",
            "srcSet": ["/static/705785abf7fb9feac42232cf3f07087d/8ff5a/HatredFortressSiege.png 240w", "/static/705785abf7fb9feac42232cf3f07087d/e85cb/HatredFortressSiege.png 480w", "/static/705785abf7fb9feac42232cf3f07087d/6af66/HatredFortressSiege.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Dahak`}</strong>{`: Directly down, use dark spot in water as marker (1 above it or on it / below)`}</li>
      <li parentName="ol"><strong parentName="li">{`(R1) Hero`}</strong>{`: Go to indicated position (left side of white water, 1 above right boat)`}</li>
      <li parentName="ol">{`While waiting, use R1 to cycle to Goesch. This will make next R1 go to Dahak.`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: Once you stop moving, move 2 down 2 right. Once in range of both ships Dawn rune. Top right ship turning and moving towards you a bit is a good indicator.`}</li>
      <li parentName="ol"><strong parentName="li">{`Dahak`}</strong>{`: After Dawn Rune, Barrage bottom left ship as soon as in range.`}</li>
      <li parentName="ol"><strong parentName="li">{`(R1) Dahak`}</strong>{`: Barrage other ship.`}</li>
    </ol>
    <h3 {...{
      "id": "raftfleet-9"
    }}>{`Raftfleet`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-9"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Maroon: Entourage`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Viki, TP to `}<strong parentName="p">{`Yashuna (2U)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "yashuna--world-map--ceras-lake-ruins"
    }}>{`Yashuna > World Map > Ceras Lake Ruins`}</h3>
    <p>{`Toma: "Hope the signal comes soon." 2m. After load mash though text.`}<br parentName="p"></br>{`
`}{`Go to Dawn Room. Zweig: "Ah, it worked!" 2m40s before control.`}</p>
    <p>{`Go down stairs to Ceras Lake Castle`}</p>
    <h3 {...{
      "id": "ceras-lake-castle"
    }}>{`Ceras Lake Castle`}</h3>
    <p>{`Zweig: "Headquarters?" 1m45s before textbox with Gizel, Alenia, Zahhak`}<br parentName="p"></br>{`
`}{`Lyon: "There's only one solution: We'll let the Prince settle this!" `}<strong parentName="p">{`Name Castle`}</strong>{` (X Start Xx3)`}<br parentName="p"></br>{`
`}{`Go to Tablet room.`}</p>
    <p>{`Go to basement, talk to Viki for `}<strong parentName="p">{`Blinking Mirror`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back upstairs, exit room from left side by stairs.`}<br parentName="p"></br>{`
`}{`After cutscene run southwest and run to Logg. Talk to him once then again and go to Beaver Dam (2U). `}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong>{`.`}</p>
    <h3 {...{
      "id": "worldmap"
    }}>{`Worldmap`}</h3>
    <p>{`Head east then south to Lordlake.`}</p>
    <h3 {...{
      "id": "lordlake-3"
    }}>{`Lordlake`}</h3>
    <p>{`Cutscene, exit, cutscene, Blinking Mirror.`}<br parentName="p"></br>{`
`}{`Teleport to `}<strong parentName="p">{`Beaver Lodge (1U)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beaver-lodge-1"
    }}>{`Beaver Lodge`}</h3>
    <p>{`Go to Elder's House, talk to Fuwalafuwalu.`}<br parentName="p"></br>{`
`}{`Fuwalafuwalu: "So, what can I do for you today?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Exit to the east, Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room.`}<br parentName="p"></br>{`
`}{`Go back to Castle 2nd Floor, exit building south for Taylor cutscene.`}<br parentName="p"></br>{`
`}{`Lucretia: "What should we do, Your Highness?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to 1st floor, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Goesch: Party`}</li>
        <li parentName="ul">{`[1D]`}{` Kisara: Party`}</li>
        <li parentName="ul">{`[2U]`}{` Zerase: Party`}</li>
      </ul>
    </Menu>
    <p>{`Back upstairs, west exit, talk to Logg to go to `}<strong parentName="p">{`Lelcar (2U)`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong></p>
    <h3 {...{
      "id": "lelcar"
    }}>{`Lelcar`}</h3>
    <p>{`Right after Wasil cutscene go Northeast to pick `}<strong parentName="p">{`White Rose Brooch`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Then go south, southeast between buildings to pick `}<strong parentName="p">{`Guardian Casque`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Then southwest to trigger cutscene. Then southwest to Wasil's house.`}<br parentName="p"></br>{`
`}{`Go southeast to Eastern Islet, southeast for cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills--equip-1"
      }}>{`Skills > Equip`}</h5>
      <ul>
        <li parentName="ul">{`Goesch: Attack`}</li>
        <li parentName="ul">{`Zerase: Incantation`}</li>
      </ul>
    </Menu>
    <p>{`After cutscene, go to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Party Items: Everything but Escape Scroll, Jizos, Lightning Crystal, Water Crystal`}</li>
        <li parentName="ul">{`Hero: Prosperity Ring`}</li>
        <li parentName="ul">{`Zerase: Star Robe`}</li>
        <li parentName="ul">{`Kyle: Everything except Lightning Amulet (Lightning Amulet if < 237415 Potch)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Had 245450 in test after selling before Amulet.`}</p>
      </blockquote>
    </Menu>
    <p>{`Northwest back to Central Islet, northwest to Western Islet. Southwest for cutscene.`}</p>
    <h4 {...{
      "id": "3-bodyguard-800hp--3-thug-900hp"
    }}>{`3 Bodyguard 800HP & 3 Thug 900HP`}</h4>
    <p>{`Zerase LVL4, rest Defend.`}</p>
    <h4 {...{
      "id": "5-thug-800hp-nikea-2000hp"
    }}>{`5 Thug 800HP Nikea 2000HP`}</h4>
    <p>{`Zerase Star Rune & Kyle Furious Blow if he still has Lightning Amulet. If not, Kyle & Prince Soaring Bolt.`}</p>
    <p><strong parentName="p">{`Do this menu before leaving building!`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-10"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Kyle: Entourage`}</li>
        <li parentName="ul">{`Kisara: Entourage`}</li>
      </ul>
    </Menu>
    <p>{`Lelei: "What's the plan, Your Highness? There's little time! We..." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Lelei: "Whenever you're ready, please issue the order to commence operations." `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-lelcar-campaign"
    }}>{`War Battle: Lelcar Campaign`}</h4>
    <h5 {...{
      "id": "setup-2"
    }}>{`Setup`}</h5>
    <ul>
      <li parentName="ul">{`Logg: Remove All `}<em parentName="li">{`Skippable, used for backup`}</em></li>
      <li parentName="ul">{`Kisara: Remove All`}</li>
      <li parentName="ul">{`Cius: Remove All. Add Kisara (1D), Logg (X). `}<em parentName="li">{`Logg is skippable`}</em></li>
    </ul>
    <h5 {...{
      "id": "reward"
    }}>{`Reward`}</h5>
    <p>{`$15000, Guardian Chain`}</p>
    <h5 {...{
      "id": "strategy-2"
    }}>{`Strategy`}</h5>
    <p>{`All Actions are Kisara. Starts bottom-left of Hero.`}<br parentName="p"></br>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/105df42a72a0052f1d4e12bb42411846/6af66/LelcarCampaign.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADrklEQVQ4yw2SaVcaBxhG58/0Y3uydcmH9KRLThpN3CMYF9ABI/sgE4YBRgQJyKoDiChgEDXGGJfkpFlMNdosTXOaDz39QbfzA97nvM9zr7BZSaL6AojlRfzbNZTHdZSdOt5EiLHxYfqHTeztVnn7qsnGksJSYpjGvIX5WSuOGQ+RiJPYnEik4GFRLyDouSQjgTIDcglfJshUbIo7oQlc9k68pnNIlqts79Y5MQKz2hAhx02iU52E7NdZCFvJxT2UrN+h23pplDMItVwOOSijVoqU5jXmQm78WY3FgoNSaoRqVmT/SYWzt5vU5E6SYxcIy734bb9wb7ITdeI6/r7vUUevUs7HEKqJFFpARonP0u2b4pbnLursLKnKEuOBKEMOH8cvV/n0bo1WYpIVuQdN/hXbwHlmTJcZG/qZrhsXMXecxy05EZZjc9jdTr7RZM6lNS7l4nw7G0JNJygWppFkBwePK/z95zqH7RSHtTgF1cXgYBd9rkE6I3ZuaVP8FhjBEvQj1JMpxHiUa0s5hhsVBteX6aktIKkq2bzCs4cy+zs67483OD16wOlxm9ajJrG4iru2iOP1Afde7XNnr42rrCNsttpomRSjeprYsk5wY5XAg2Wq4WnKVZ0nB1WOntf5692OEbrO6Zs2B9s5duoRmpV5GlGR1fkIC+kwRQOwkM3Mk1JkiqU8tZUy+WKGeD7JdivG0z2ds9NHnL6o8mo7wenrJmfGnu9PNjg5avH7YYmtlI+tRo7lRoHW2hJCyO9ltLcL74QVRQ4SCkeRfR6W9BhnxkcfzlocPS6xp6scNpJsFFW2tsq014ucHOg8zQZpJ4I8KCZ4uLKAkE/M4rKJyAYYyenG7ZHwOOwU7k/z/o81Pn/c5sveDmfP2rzcKhKOqDjDEbrHRCbddwkoHsZUCZd3Eq8kIiQkGdtgP6KpmxFTF2M9N7AN9RAyfJxJxVhp5vhiUP7nzaaxZZPg/TTRvI7VI3PRaHclG+NafZGb9RI/ZSJGZaeTr29e5weLiQs2C5fMfVzp7cA6IWJyTjNoc/FpLcd/e1U+PG/QLMeoVeKs6jNYFuJ0765z7+Mx2r+fEY9fIChuia+GBrjocXBNDXDFZ+fHiWHGrSYCkhnzqJl8LkxzJc3aaopkzMVdr5Nx8Q5DMxJ9hhm+R238+zv4j18iaH4PlxUfN7JxeotpOhYy3I5KpLV+7I5hBm73MqO5yRhalPQ4rqDCuMdHt9lCv6LQkZ3DbNy5mlXE3Q3+Bx7uu9JSLGU6AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Lelcar Campaign",
            "title": "Lelcar Campaign",
            "src": "/static/105df42a72a0052f1d4e12bb42411846/6af66/LelcarCampaign.png",
            "srcSet": ["/static/105df42a72a0052f1d4e12bb42411846/8ff5a/LelcarCampaign.png 240w", "/static/105df42a72a0052f1d4e12bb42411846/e85cb/LelcarCampaign.png 480w", "/static/105df42a72a0052f1d4e12bb42411846/6af66/LelcarCampaign.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move to P1 (directly left). Must be done quick!`}</li>
      <li parentName="ol">{`As soon as in Barrage range, Barrage Cavalry. Good visual marker is instantly as soon as infantry starts turning southeast. DO NOT LET INFANTRY REACH BRIDGE.`}</li>
    </ol>
    <h3 {...{
      "id": "lelcar-1"
    }}>{`Lelcar`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Get autohealed after War Battle.`}</p>
    </blockquote>
    <h5 {...{
      "id": "6-godwin-soldier-1000hp"
    }}>{`6 Godwin Soldier 1000HP`}</h5>
    <p>{`Zerase LVL4, rest Defend. Drops 13050 base, 14355 with Prosp. Sandals.`}</p>
    <p>{`Head `}<strong parentName="p">{`Northwest`}</strong>{`, trigger cutscene. If you get a battle Star LVL4.`}<br parentName="p"></br>{`
`}{`Lelei to Entourage.`}</p>
    <p>{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-4"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Lightning: Kisara RH`}</li>
        <li parentName="ul">{`Water: Kisara LH`}</li>
      </ul>
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Double-Edged Orb x2`}</li>
      </ul>
    </Menu>
    <p>{`Go back to Central Islet, then back to boat (2s faster than Blinking Mirror).`}</p>
    <h3 {...{
      "id": "castle-1"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room. After Cutscene, go to 1st floor.`}<br parentName="p"></br>{`
`}{`Talk to Mirror to TP `}<strong parentName="p">{`Lordlake (X)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "lordlake--world-map"
    }}>{`Lordlake > World Map`}</h3>
    <p>{`Go east then southeast.`}</p>
    <h3 {...{
      "id": "sable-checkpoint"
    }}>{`Sable Checkpoint`}</h3>
    <h4 {...{
      "id": "sable-patrol-guards-1200hp"
    }}>{`Sable Patrol Guards 1200HP`}</h4>
    <p>{`Lyon Soaring Bolt, Zerase LVL4.`}</p>
    <p>{`Dinn & Boz to Entourage.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`This is for better preempt & ambush rate.`}</p>
      </blockquote>
      <h5 {...{
        "id": "swap-11"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Sialeeds: Entourage`}</li>
        <li parentName="ul">{`Dinn: Entourage`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "world-map-11"
    }}>{`World Map`}</h3>
    <p>{`East, Southeast below bolder, east till road, southeast a bit then east again.`}</p>
    <h3 {...{
      "id": "sable"
    }}>{`Sable`}</h3>
    <p>{`Go to inn, rest, then head to Ranro Mountain.`}</p>
    <h3 {...{
      "id": "world-map-12"
    }}>{`World Map`}</h3>
    <p>{`Go around 1st boulder, slightly northeast then east.`}</p>
    <h3 {...{
      "id": "ranro-mountain"
    }}>{`Ranro Mountain`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6c02ff05b56816d9aa0bb251b8a3332a/c1724/RanroMountain.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "77.08333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAB0klEQVQ4y41TXWviUBDN//bBB6H6ZPFBWCx2Yan45Nf6BYK69QMUtFVEBD8Siz5UUau4YjEmp3dGY2NQ6oHDJLlzzz1zZyLhCF3XmQRN07Df7zkSQWvHnJ8gWT9c2qQfFnALpEsO2+02is/PqLy+oPvnCZqsHHKEWyPPnG82cSbI5QlkMhncu93odLsY5P8ByyWu+bNWdFayISjLMrxeL9xCdLJY8Dd1t8Nms8F6vRb6S6xWq1P+VYcEagah1WoxzUin03C5XEgkEohGoyx+VdBadjAYhN/vRzgcRiqVQjabhc/nY9GbSjZfsOEyl8vB4/HwFTSbTW5Wv9/HdDpld9qxSeb9krnD1tNGoxE7qlQqKJfLKBaLqFarcDqdGAwGuGRGstomd4qioNPp8KbhcMjReCbSdSxEsxqNBrbb7blD44FKoC6Ox2M4HA4enUKhgHw+zyyVSgiFQrDZbOj1enyo3W7H+2QCVVXPHdbrdUQiEd4Yj8dRq9UuztxOjA41icqnvK6Y08cHH94U+TR2LBgIBJjUTUqkSAeYSUKxWAzJZJJjQsS/kTDufv3GTD38oCeHZHk+n2M2m51I71aa1zgKLv5v8fG5/y5Zv/Gn/wmGzhcvr2AHPJHI4gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Ranro Mountain",
            "title": "Ranro Mountain",
            "src": "/static/6c02ff05b56816d9aa0bb251b8a3332a/c1724/RanroMountain.png",
            "srcSet": ["/static/6c02ff05b56816d9aa0bb251b8a3332a/8ff5a/RanroMountain.png 240w", "/static/6c02ff05b56816d9aa0bb251b8a3332a/c1724/RanroMountain.png 304w"],
            "sizes": "(max-width: 304px) 100vw, 304px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <Menu mdxType="Menu">
      <p>{`At top, before fight.`}</p>
      <h5 {...{
        "id": "swap-12"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Kisara: Party`}</li>
        <li parentName="ul">{`Sialeeds: Party`}</li>
      </ul>
    </Menu>
    <ol>
      <li parentName="ol">{`Go west and up vine.`}</li>
      <li parentName="ol">{`East and up vine.`}</li>
      <li parentName="ol">{`East and up vine.`}</li>
      <li parentName="ol">{`West and up vine.`}</li>
      <li parentName="ol">{`West and up vine.`}</li>
      <li parentName="ol">{`West and up vine.`}</li>
      <li parentName="ol">{`East`}</li>
    </ol>
    <h4 {...{
      "id": "faylon-2000hp-faylen-1800hp-bandit-1200hp"
    }}>{`Faylon 2000HP Faylen 1800HP Bandit 1200HP`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Lyon: Soaring Bolt`}</li>
      <li parentName="ul">{`Kisara: Furious Blow middle Column (1D)`}</li>
      <li parentName="ul">{`Zerase: Star LVL4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Want Sialeeds to live here for EXP, want a LVL4 spell`}</p>
    </blockquote>
    <p>{`Enter left room. 2m35s before dialogue.`}<br parentName="p"></br>{`
`}{`Roy: "Then I get to take your place as prince!" Option 1`}</p>
    <h4 {...{
      "id": "roy-duel"
    }}>{`Roy Duel`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Watch out for super move at <50% HP`}<br parentName="p"></br>{`
`}{`Guard is .5s faster than Special.`}</p>
    </blockquote>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ah ha ha ha! Here, have another one!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All right, this one is gonna put you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special / Super`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`And now for the feint...This'll do...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`C'mon, what's the matter? I'm nowhere..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Damn it!! Just try that again!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Damn you, that really hurt!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`D-damn you... You really got me...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Grrrrr!! You really piss me off, you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmmm. Maybe I'll hit you with my best..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmph. How 'bout if I really get...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmph. If this ends things, how boring..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmph. Think that'd hurt me? Come at...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmph. Think that'd hurt me? You gotta..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`How'd you like that? I'm gonna make...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I don't feel like having some kind of..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'll be able to handle it next time!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Is that the best you can do?! Well...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`It's no fun if we both use nothing...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Let's hit each other with our best...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, here comes another one!! ...Nah,`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tsk. It's like looking at my own face..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tsk tsk tsk! What a loser!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well, I'm not gonna hit you with my...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`What are you waiting for? Come at me!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`What is this, an endurance contest? ...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Y-you got me... I gotta take a break...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Roy: "I was ready to die from the start, anyway! C'mon Prince! ..." `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip-all-3"
      }}>{`Unequip All`}</h5>
      <p>{`Roy`}</p>
    </Menu>
    <p>{`Use `}<strong parentName="p">{`Escape Scroll`}</strong>{` to exit Ranro Mountain.`}</p>
    <p><strong parentName="p">{`Blinking Mirror`}</strong>{`, TP to `}<strong parentName="p">{`Sable (1U)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sable-1"
    }}>{`Sable`}</h3>
    <p>{`Go to Raubel's house and go upstairs.`}</p>
    <blockquote>
      <p parentName="blockquote">{`All autohealed before & after	Euram fight.`}</p>
    </blockquote>
    <p>{`Sialeeds: "All right, here goes nothing!" 2m10s before battle start.`}</p>
    <h4 {...{
      "id": "euram-800hp--5-bodyguard-1000hp"
    }}>{`Euram 800HP & 5 Bodyguard 1000HP`}</h4>
    <ul>
      <li parentName="ul">{`Hero: Soaring Bolt`}</li>
      <li parentName="ul">{`Lyon: Soaring Bolt`}</li>
      <li parentName="ul">{`Faylen & Faylon: Co-op Bodyguard #2`}</li>
      <li parentName="ul">{`Sialeeds: Funeral Wind`}</li>
    </ul>
    <p>{`Go to Raubel's house.`}</p>
    <p>{`Solis: "I must offer you my sincere gratitude, Prince." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Add Dinn, Boz, Roy to Entourage.`}<br parentName="p"></br>{`
`}{`Exit Sable, Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-2"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room. Then go to your room.`}<br parentName="p"></br>{`
`}{`Lyon 1 Textbox Option 1.`}</p>
    <p>{`Go to 1st floor, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-2"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[4U]`}{` Kyle: Party`}</li>
        <li parentName="ul">{`[3D]`}{` Kisara: Party`}</li>
        <li parentName="ul">{`[1R1D]`}{` Zerase: Party`}</li>
      </ul>
    </Menu>
    <p>{`Can TP or run from castle. Odds of battle are lower from castle.`}<br parentName="p"></br>{`
`}{`Assuming no battle, TP is 14s faster. A 1st try retreat also costs ~14s.`}</p>
    <p>{`If TP, Viki 2 Textboxes then `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If run, go back to 2nd floor and exit from left. Then run down stairs and back around to right side.`}</p>
    <h3 {...{
      "id": "beaver-lodge-2"
    }}>{`Beaver Lodge`}</h3>
    <h4 {...{
      "id": "assassin-1800hp"
    }}>{`Assassin 1800HP`}</h4>
    <p>{`If Lightning Amulet: 1st one Kyle Furious Blow & Zerase LVL3`}<br parentName="p"></br>{`
`}{`Otherwise, Kyle Soaring Bolt, Zerase LVL3, Kisara Berserk Blow`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-13"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Maroon: Entourage`}</li>
      </ul>
    </Menu>
    <p>{`If you haven't gotten it already, force another `}<strong parentName="p">{`Assassin battle`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Enter Chief's house.`}</p>
    <h4 {...{
      "id": "dolph-3000hp"
    }}>{`Dolph 3000HP`}</h4>
    <ul>
      <li parentName="ul">{`Hero: Soaring Bolt`}</li>
      <li parentName="ul">{`Lyon: Defend`}</li>
      <li parentName="ul">{`Kyle: Soaring Bolt`}</li>
      <li parentName="ul">{`Kisara: Soaring Blow`}</li>
      <li parentName="ul">{`Zerase: Comet`}</li>
      <li parentName="ul">{`Maroon: Defend`}</li>
    </ul>
    <p>{`Go outside. Goesch and Toma to Entourage.`}</p>
    <blockquote>
      <p parentName="blockquote">{`All autohealed here.`}<br parentName="p"></br>{`
`}{`If money is tight can unequip Lightning Amulet.`}</p>
    </blockquote>
    <p>{`Exit East & Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-3"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room.`}</p>
    <p>{`Boz: "What do ya think, Prince?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Luserina: "It's alright, I understand." 2m55s no input.`}</p>
    <p>{`Go to War Room.`}<br parentName="p"></br>{`
`}{`Go to 1st floor, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Dinn: Party`}</li>
        <li parentName="ul">{`[2D]`}{` Faylon: Party`}</li>
        <li parentName="ul">{`[2D]`}{` Goesch: Party`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Mirror, TP `}<strong parentName="p">{`Haud Village (1D)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haud-village--world-map"
    }}>{`Haud Village > World Map`}</h3>
    <p>{`Head southeast, roughly following road. Once past bridge head southeast.`}</p>
    <h3 {...{
      "id": "estrise"
    }}>{`Estrise`}</h3>
    <p>{`Talk to Appraiser. Appraise & Sell `}<strong parentName="p">{`"The Sacred Games"`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-5"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Jizos onto Faylon, Goesch`}</li>
      </ul>
    </Menu>
    <p>{`Go to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-6"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Double-Edged: Faylon Left Hand (Bottom Slot)`}</li>
        <li parentName="ul">{`Double-Edged: Goesch Left Hand (Bottom Slot)`}</li>
        <li parentName="ul">{`Firefly: Georg`}</li>
        <li parentName="ul">{`Crazed: Faylon Right Hand`}</li>
        <li parentName="ul">{`Crazed: Goesch Right Hand`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Combat Trainer.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "train"
      }}>{`Train`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Goesch`}</strong>{`: Attack - C`}</li>
      </ul>
    </Menu>
    <p>{`Go all the way southeast, pick `}<strong parentName="p">{`True Men Tactic`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Armor Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-want-198500-198000-if-runes-done"
      }}>{`Sell (Want 198500, 198000 if Runes done)`}</h5>
      <ul>
        <li parentName="ul">{`All Party Items `}<strong parentName="li">{`EXCEPT`}</strong></li>
        <li parentName="ul">{`Escape Scroll`}</li>
        <li parentName="ul">{`Jizos`}</li>
      </ul>
    </Menu>
    <p>{`Go back left then up, talk to Rune Shop.`}</p>
    <p>{`Go upstairs to dock.`}</p>
    <p>{`Boz: "Good luck..." 1m20s no input.`}</p>
    <h3 {...{
      "id": "nirva-island"
    }}>{`Nirva Island`}</h3>
    <p>{`Skald: "Skald Egan, Admiral of the Island Nations Federation fleet." `}<strong parentName="p">{`Option 2`}</strong>{` 1m35s no input after.`}</p>
    <p>{`Head west, up stairs, northwest then north to next screen.`}<br parentName="p"></br>{`
`}{`Go to Blacksmith on the left side.`}</p>
    <Menu mdxType="Menu">
      <p>{`Costs 198000 for 3 LVL10`}</p>
      <h5 {...{
        "id": "sharpen-up-to-select-goesch"
      }}>{`Sharpen (Up to select Goesch)`}</h5>
      <ul>
        <li parentName="ul">{`Goesch: 10`}</li>
        <li parentName="ul">{`Faylon: 10`}</li>
        <li parentName="ul">{`Dinn: 10`}</li>
      </ul>
    </Menu>
    <p>{`Leave blacksmith, northeast up stairs then east to lighthouse.`}</p>
    <p>{`Lyon: "Prince, what do you think?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bernadette to Entourage.`}</p>
    <p>{`Enter Lighthouse, go slightly northeast and follow staircase.`}<br parentName="p"></br>{`
`}{`Before final stairs pick `}<strong parentName="p">{`Striking Tactic`}</strong>{` from bottom right chest.`}</p>
    <p>{`Lyon: "I'll climb the ladder, then." `}<strong parentName="p">{`Option 2`}</strong>{` (For -Georg Affection.)`}</p>
    <p>{`Exit lighthouse, go to ladder and follow all the way up.`}</p>
    <blockquote>
      <p parentName="blockquote">{`To climb ladders, talk to them with X and hold up.`}</p>
    </blockquote>
    <h4 {...{
      "id": "5-pirate-lackey-1500hp-1-pirate-captain-2200hp"
    }}>{`5 Pirate Lackey 1500HP 1 Pirate Captain 2200HP`}</h4>
    <p>{`True Men`}</p>
    <p>{`Go back down Lighthouse.`}</p>
    <p>{`Talk to guy by dock to go back to Estrise, 1 Textbox then `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After next textbox 1m no input.`}</p>
    <h3 {...{
      "id": "estrise-1"
    }}>{`Estrise`}</h3>
    <p>{`Talk to Item Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <p>{`Sell everything but Escape Scroll`}</p>
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`4 Jizos: Goesch & Faylon`}</li>
        <li parentName="ul">{`2 Jizos: Dinn`}</li>
        <li parentName="ul">{`9-12 Jizos depending on how many we had left. (had 106k here)`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip-2"
      }}>{`Unequip`}</h5>
      <ul>
        <li parentName="ul">{`Lyon: Lightning`}</li>
        <li parentName="ul">{`Georg: Firefly`}</li>
      </ul>
      <h5 {...{
        "id": "equip-7"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Lightning: Bernadette RH`}</li>
      </ul>
    </Menu>
    <p>{`Exit town & Blinking Mirror`}</p>
    <h3 {...{
      "id": "castle-4"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room.`}</p>
    <p>{`Lucretia: "We're in for some rough times ahead." 1m55s no input.`}</p>
    <p>{`Go to War Room.`}<br parentName="p"></br>{`
`}{`Lucretia: "Prince, if you had to raise a sword against your sister, ..." Option 1`}</p>
    <p>{`Go to War Room. Lucretia 1 Textbox `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-doraat-siege"
    }}>{`War Battle: Doraat Siege`}</h4>
    <p>{`No setup.`}</p>
    <p>{`Only Prince moves in this fight.`}</p>
    <h5 {...{
      "id": "strategy-3"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/31d28c9a4335753199472fc3a7b41309/6af66/DooratSiege1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADIUlEQVQozx2QaW/aBgCG/VOmSZOmHV8qdVL7IZGWNiFJm7HAnEEo4AvCFYNxcLhNTELA5vKB8YEPDMGEki1NOzWatH7YH1u0z68ePY9eYPaP7rptYVIXJLg3CLRZP33xpkZ7rju/ShokjCNi64SrnZB5D5rcTOJ7cPx1qbRLEFsNzg8sP/UD+CBIDFpNqELun8Zf5OIvkoGfapl912y59iWT90cPn/l2vz70fJWENjB4mws/78XBQs0LzNdki0c6I4wfwz0hxHaORmx61DldKlef5upft8aA8JaOn+PoRuS3H30H3wa9P0TefpMAv+8O/IBoI4oDKzYsW4hixmZ25d6RP8xHa1tUu4zMNtRqTLmAuu2QRu50sZcx7GXo6Lsk+ozt+wDZQSULFrSoqIZ1I+EarSeZ1KrTuXQ1Ey8lkfZZ/IPRW0rMTR0yS1tMc4+ubl823/BKGNDdE2WO/c9HVCO2nrJTkWPIzHWJEqsYX0yaPLvUO4ZCChoqTFHJhnkTGs8T+jILyFPkmg/Q3JE6j6kmZqjkHxa/0vv3i/Gjqn205fsbYWl0+FF0ZEUlC+kq7wZ6RLQheY4CLf731JknSe7yGiRbqKhHbZ26M4UHV3/UlIfV0FlUJC3+tPIG1FVCw0nUWOHKTYI3I8BQxWKnP+PUXoH2n9fBfH6XKh0YGrEyubuZ4Bg1x61O1+fSFBXtqGBBzp/Uw5eOtco9nQX0ZBTLvMLw7Sy1TxTeZvAdPL/TV4Izq3xnCXfTgWNQyjRu3ubVRXI8R43bjLZISTY6djCg2QOh9GYo/SpG7iD4ZiL7Ol/eZ+XAUI7YSnmhX2lqmhWP+Ak0XZ/Z74m++q47Pn5KkB0EYIYgim/hRV+FOS7XwQs61GORv/9lP3+5/PhIP3yuOeus7ibUBSbPYG2Rtm5zyiwmz9C2FAYW7ys0HWWaCN0IV2rBs6KvVAElNa1MCGNWmFiVG7dhzc6FcYrhQufML+XrIDdKlRvgMbYBKHaq2DgsXRxStJesHWQoD05tE4SXplJlKpIlwUozwHCRoZSx7frELBauILIBNllEmuT+A5W2ovxCSyGxAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Doorat Siege 1",
            "title": "Doorat Siege 1",
            "src": "/static/31d28c9a4335753199472fc3a7b41309/6af66/DooratSiege1.png",
            "srcSet": ["/static/31d28c9a4335753199472fc3a7b41309/8ff5a/DooratSiege1.png 240w", "/static/31d28c9a4335753199472fc3a7b41309/e85cb/DooratSiege1.png 480w", "/static/31d28c9a4335753199472fc3a7b41309/6af66/DooratSiege1.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3088aa797d837de2c2c1ae33d291855b/6af66/DooratSiege2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADpklEQVQ4yx2Ta1NaVxSG+TP91Jl2jCZqTUdTb+ANBQ4ieJS7EhEVFRVFBkRQEJSbV5CDt0him5jMmMnFdqbpp2baL53+nqfbfliz5+yZ/Zz3fddaqvzLfaYvFXxKCW9pB+9xgqOLCOenXjaTOqKpXrLKOMcXk2TzFraTEvm8jcS2jlhCS0J8F4oSuayeTNaEqpAL4/SlCU8lSEQDbG06icyrcVsbGdZ+g3+6ib2yzO6RzJy3GYf8PRNj9UyMfkdwrpP5WQ07Y4/YcUnEUhIqR63ManSJmm+St8o6J1UvvsUOTPYWBi1NyJ42VuI6fCs6/HIDAflbfFOPmZqow+V8xOxkMwHnE5YdjZyeulEF/rwn/fmKL3e7/PV3mU9f0mwVnQRiJlYSIyyJs1Kbo3S5QHJB4iAyRmpnmNPVbpSlHjYjRpZn2oXads7OplG9+CXJ+/s47+5jvPmwwfVtiN/+yIhK8+HXJNspL6VqkE+/J7hS5qhVVqkUZ1HCRiqhTmJbA4TXutiIaEjlhOXl0Ajp/XGW4wa861rGvWrWYhIbaROrMT3bOZlIcoTM8RjFMxuF6ji12yVe3YWovPZTUBzizsXhpYujMyeq/IWNfNVGOG3EPtONZG5HsrRhm2rHs6gmd2pl/9xJvmKjWLXz9mOMf/695uvXMu8+bhDJWvBHJdInAijAqkxVJlMdpSDAibyJxegggaiOjV0T+2JUSi99QpmbwyvxoCyg6VFe3C5TvZnl8MJNMK7HvaghXhjl5FI0ZTM7jHexC99StygN3vku/AtdrG3qOb7yCDsOihUr5SsfB1kXiXkNu8cyx+Jx4UG1YhfqrRycOzgStlWB9T769fVozT9gcvxIv6kJs62F6YCafWHh5GaGUtHG5dGs6HaI0vlzCud2copNQJz/x/Dwg4doCgKucouWa6UnDJh/YnC0VQBbMFlbkORmokkD+XMPtcM1Xl+uolTs7Ilodk7NpETlFCvZspWTq+ec/eynXBNjo5OfodY2IVnV6GU1BksLQ4Z6DMbHRFJ6gsL6XnlCWJ4Q6hyUb8T5akLka6dU8wiQj5v3Qd58DvPyLiiA1h569U/RmZ/RoWmkf6ieHm0dvQN1DAulA8ONjE22siJGKbRlZD1hEPttIr4rk8zbxRJ4SBbdbOXslK/nUbUNaejQPqXf2Eqv1ITOIqAigk5tA90C3GdoQC9W0DHdRyhuEbNpJLhhJJZ2kD30EUy6iGenyBSnOaj6+A9jCqHwNhYXegAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Doorat Siege 2",
            "title": "Doorat Siege 2",
            "src": "/static/3088aa797d837de2c2c1ae33d291855b/6af66/DooratSiege2.png",
            "srcSet": ["/static/3088aa797d837de2c2c1ae33d291855b/8ff5a/DooratSiege2.png 240w", "/static/3088aa797d837de2c2c1ae33d291855b/e85cb/DooratSiege2.png 480w", "/static/3088aa797d837de2c2c1ae33d291855b/6af66/DooratSiege2.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move Northwest to center tile right below lake (1st image).`}</li>
      <li parentName="ol">{`When almost there, move to P2`}</li>
      <li parentName="ol">{`When around the spot where Prince is in 2nd image, move to P3.`}</li>
      <li parentName="ol">{`After Twilight Rune scene move into Fortress`}</li>
    </ol>
    <h3 {...{
      "id": "doraat"
    }}>{`Doraat`}</h3>
    <p>{`Talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[3U]`}{` Goesch: Party`}</li>
        <li parentName="ul">{`[] Bernadette: Party`}</li>
        <li parentName="ul">{`[3D]`}{` Faylon: Party`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Bringing Dinn causes a ~7 load.`}</p>
      </blockquote>
    </Menu>
    <p>{`Open door, head straight along road to Fortress.`}</p>
    <p>{`All Battles: True Man`}<br parentName="p"></br>{`
`}{`Heal after all with Bernadette Kindness Rain`}</p>
    <h4 {...{
      "id": "alenia-2700hp-5-godwin-soldiers-1500hp"
    }}>{`Alenia 2700HP 5 Godwin Soldiers 1500HP`}</h4>
    <p>{`True Men. Looks like you want all alive for Alenia kill. But if she survives Striking Arrow.`}</p>
    <p>{`Heal after battle if needed. Any battles you see use True Men.`}</p>
    <p>{`1m45s no input after battle.`}</p>
    <p>{`Enter northeast door. Northeast door and pick bottom chest for `}<strong parentName="p">{`Blinking Rune Piece`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Consider skipping this and picking it up in Ashtwal Mountains instead.`}</p>
    </blockquote>
    <p>{`Exit room and take southeast stairs.`}</p>
    <p>{`Do this menu before Miakis duel.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-8"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Goesch: 4 Jizos`}</li>
        <li parentName="ul">{`Faylon: 4 Jizos`}</li>
      </ul>
    </Menu>
    <p>{`Lyon: "But Miakis!" Option 1, 50s before option, 35s before duel start after.`}</p>
    <h4 {...{
      "id": "miakis-duel"
    }}>{`Miakis Duel`}</h4>
    <p>{`Special vs Special is .8s faster.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All right, Prince. Show me how good...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All right, no time to recover!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Big moves like that tend to create...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Come on, you can do better than that!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Didn't I ask you not to hold back?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't you want to settle this quickly?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hey that really hurt! Are you trying...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hey, that really hurt! Now you're going`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I guess I ought to be a little more...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I guess you are a boy, after all. Now..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`If you don't start getting serious, ...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`No! I won't give up yet!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Now I'm going to get really serious!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Oh, my... Are you all right?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, here I come!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch, that hurt!! I'll get you this ...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ow, ow! Now it's my turn!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ow, ow, ow! You've really got your...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Phew! I feel a little tired...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Phew! My arm is tired.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prince, can you handle this one?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prince, let's put an end to this!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`So that's the way you like it, huh? ...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Think you can withstand it this time?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Time for you to go beddy-bye!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`What do you think of this, then?!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You'd better stop dawdling or little...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Last action of duel > textbox is 1m10s`}</p>
    <h3 {...{
      "id": "castle-5"
    }}>{`Castle`}</h3>
    <p>{`Go to Tablet Room, talk to Zerase.`}<br parentName="p"></br>{`
`}{`Zerase: "Now that the Twilight Rune has been used, we must quickly--" 2m35s no input.`}<br parentName="p"></br>{`
`}{`Downstairs, cutscenes, Castle upgrade.`}</p>
    <p>{`Alenia: "`}<em parentName="p">{`sigh`}</em>{` I will always do what is in the best interest of my nation..." 2m15s no input.`}</p>
    <p>{`Go to War Room.`}</p>
    <p>{`Lucretia: "Okay, let's build on this group. Who else would you like to accompany Roy and Zerase?"`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "roys-party"
      }}>{`Roy's Party`}</h5>
      <ul>
        <li parentName="ul">{`[1R1D]`}{` Lorelai`}</li>
        <li parentName="ul">{`[] Bernadette`}</li>
        <li parentName="ul">{`[3U]`}{` Kisara`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Want Faylon to have at least 388ATK. If less, consider reverting to previous strat and adding a few people to tank hits and go True Men + Striking Arrow. If training Attack early, assume Goesch is higher, otherwise assume Faylon is higher.`}</p>
      </blockquote>
      <h5 {...{
        "id": "kyles-party"
      }}>{`Kyle's Party`}</h5>
      <ul>
        <li parentName="ul">{`[3/4D]`}{` Faylon / Goesch (Whoever has higher attack.)`}</li>
      </ul>
      <h5 {...{
        "id": "heros-party"
      }}>{`Hero's Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Dinn`}</li>
        <li parentName="ul">{`[2/3D]`}{` Faylon / Goesch`}</li>
      </ul>
    </Menu>
    <p>{`Go to your room, talk to Maid. Option 1`}<br parentName="p"></br>{`
`}{`Maid: "Pleasant Dreams!" 1m55s no input`}</p>
    <h4 {...{
      "id": "war-battle-new-queens-campaign"
    }}>{`War Battle: New Queen's Campaign`}</h4>
    <p>{`No Setup. All movement is Roy.`}</p>
    <h5 {...{
      "id": "strategy-4"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0e29634369d02ada846612cd576165b5/6af66/NewQueensCampaign1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADKklEQVQozx2RW2/aBgCF/Ve2hz2skyatk7o1aiUKbZWOhTQlELpwSQgkhEBsA7axgYADtrnfL6FLwPiGcQzGXNqs0V76x4b2eB6Ojs73AQMRvP102u+cVMrubgW6KcVazGWTuRjUiZV8q4nNuxZSIs+g6NtQxOgPGnznhnjCRJLbCcoGDNjgV4HUR0k6cUhCB+nwPhVzor6dVPAD26C5ViHiNX4wf283/2B9992Za8vrfFV2/Vo5s3sDJkBSooNhgL2Fhm2CbVwN66kifk4EnMmgOwuHM3Ao6TZc2n502X863H3itv0ScD0Nffw5aHsSA83AWEMnGnEv0hrffpzzU7aTxyIUEqXRKBUDKQym/H9e+V7F8d2biKkfepuKWy58z8K+Z4MGDGgP6ameUVjm/q62lPozttWhU3USr6bjhXiMxpASdtIg4V4xpWYv5MTHPGPNENu5tHk8SACijnb4IFk8ype9NOPlb/KfJ4M5150OW5O7ao88H9Zpnet+mfYVtqoqZXmOyHqcVSBeQIC+FMYKjlBqF6etIeTdbSO7lG+mbEOXu4t2fd1jFmJ3KtYWQk/kCH4Mi3NsvCSEGcIqMIBR++GEBbyyBFAznNyZyOmHVfeL3n54bP8jNx/U0XzSVEc1hWPGKi7MYvwMETRUWsblFQ44T1+7/SaH23h4bITxA4zyF1qn2mNGXRHqOrlQGnO+o43aqkiJM1TSNx1CXuKbcV5DAI9v23rw8v3+c4v1tz3H1jG4BxE2UY1O1yltkZ1LDW3UWQh/60JHYkn+Pjpe4pN1Qv+XWn8rAXuurW3LU4fn+XHAACE7l6gFy9jHGqYscPU+u4G/sSANqcV4A6IpT5KcEmFliFXhySoB2I8MR+4Xocjri8gbBN+BsPdXedfsa1rSEUVNaUJRF9ozqTIXG9NheTiCBuMLbgpzWmSjafP5pdPzuz9k8IeNZ6ApAL65RP+g6+5czcNUj4sM2KuQrRJeZ2J0zpe83kezB7VPYJeNcTMc6HHBdP6vdN65UZ2r+q/LR//Hw3TBQ2QdGOnO14K50kmu4it3QrUemG1HriuBUiMkzTL/ASpSrzHhajvRAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "New Queen's Campaign 1",
            "title": "New Queen's Campaign 1",
            "src": "/static/0e29634369d02ada846612cd576165b5/6af66/NewQueensCampaign1.png",
            "srcSet": ["/static/0e29634369d02ada846612cd576165b5/8ff5a/NewQueensCampaign1.png 240w", "/static/0e29634369d02ada846612cd576165b5/e85cb/NewQueensCampaign1.png 480w", "/static/0e29634369d02ada846612cd576165b5/6af66/NewQueensCampaign1.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0dc05313644f4e02bd3395929fd60ba7/6af66/NewQueensCampaign2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADNUlEQVQozxWPaW/aBgCG/YM2aZvaTJs0bVq7RNmo0qSd0gSXQGpiwOawwQZj8IGBEHC4EhsIRwCbIzAOAyGlkGTNlmSbNG3q/tBS6f30fHgevcDZmFYUtHJqyeYMGQnMSPpUdvtA/DmefFlQoVLb+gCjsbV4YkOSDeLhi3Dkp9Thaiqpy+T1QK3pmqmcVgtGuS2G1LnRb3zYU6/zOwr7ISyCuboRhZbAl5/Chi/2wE8Yz6rHqUsal5Lw5n5SD/QvuMG50B8L9ba7WLWkJX3yaFsumRIJkIkYyplXzO6XBPgZ7vjKDj+yQo9R02N853Nidyl1pAeaI7z7lu7P+cnNQXfGtMaUdilc/BbXroTx4KNU4p5zlu8Zfr3ofXKMfksQK7a9r7348qniBFoTX62HltrmWs9ZbNqp0HO5Bpea6GAhdKtsZxBMxkEa3xZjiCKAZXo5EtPxwWWGfiqdvH4o+8/O6Ybm+bghwR68IkPrQuoNEzdAnhUX/YxkNw7zu4qG59rWXNtSbpkLDeikCZdaFkAZEp1pYHwVmVxH+zNWW0QLKunmNt3chtL3T66Tdx+q8/ujep8stpBqz1FsI3IdyismuW4COhfMYM6PrsLDRXi0iEwW0cVt9pdp6PKPzP2H0p//nb79PZ3MWzFqTa4hvVmwOSLLZ0ipBcv1XSB1YrZ7dDC2Eowa4lmIEjbFLKS94xd36Zu/C1d/HYsFyOp7xorgxc3++fv93oxrjMhaDy+oNgBCn6zqHu1BLxyOLSe+ZnP9SLHrxQZcOUPqPVd3GmhqFCu+drAbzOGOMvA1R15VI+tDotyxAwi27vOYedLJkUiAhDwYGOS2ql2sNSTVgaPWRRoDp9rHpLo9nN5RB9RwznemdHvib00ooJilKWQngFtZNxIgbBhiYPk340Voeh0Z/xrpz9nRJXv+nrv9V7r9R3p3l5jfi9ol358z6pAACmka29NTDovfbXPbjKTdTOGm/YTp4X+qgIiy87iCS6eYVMGKiq/SpHMqnS27RBk+abiASi4UZTEhiCY4b4xzxUKowEGB8BYfNwoixMVtqZwrKdvTeZdUInIljz8BsQljIgtXO+T/KwW6B7FBCCoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "New Queen's Campaign 2",
            "title": "New Queen's Campaign 2",
            "src": "/static/0dc05313644f4e02bd3395929fd60ba7/6af66/NewQueensCampaign2.png",
            "srcSet": ["/static/0dc05313644f4e02bd3395929fd60ba7/8ff5a/NewQueensCampaign2.png 240w", "/static/0dc05313644f4e02bd3395929fd60ba7/e85cb/NewQueensCampaign2.png 480w", "/static/0dc05313644f4e02bd3395929fd60ba7/6af66/NewQueensCampaign2.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move to tile in image 1.`}</li>
      <li parentName="ol">{`When close/on tile #1, move to tile in image 2 (1 tile DR Alenia.) 1 Tile below Alenia works too.`}</li>
    </ol>
    <h4 {...{
      "id": "alenia-2800hp-5-elite-soldier-1200hp"
    }}>{`Alenia 2800HP 5 Elite Soldier 1200HP`}</h4>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Switch Formation to Arrow Stance`}</strong></li>
      <li parentName="ul">{`Roy: Defend`}</li>
      <li parentName="ul">{`Zerase: Meteor`}</li>
      <li parentName="ul">{`Lorelai: Soaring Bolt`}</li>
      <li parentName="ul">{`Bernadette: Soaring Bolt `}<strong parentName="li">{`(NOT SILENT LAKE)`}</strong></li>
      <li parentName="ul">{`Kisara: Soaring Bolt`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Zerase: Comet`}</li>
      <li parentName="ul">{`Rest: Soaring Bolt `}<strong parentName="li">{`(NOT SILENT LAKE STILL)`}</strong></li>
    </ul>
    <h4 {...{
      "id": "zahhak-2500hp-5-elite-soldier-1200hp"
    }}>{`Zahhak 2500HP 5 Elite Soldier 1200HP`}</h4>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <p><strong parentName="p">{`Twin Slash`}</strong></p>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <p>{`True Men`}</p>
    <blockquote>
      <p parentName="blockquote">{`If still alive, use True Men again. He has a very high chance of Parrying and if you lose it's game over.`}</p>
    </blockquote>
    <p>{`Galleon: "I shall faithfully fulfill that duty! I must protect the Queen!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "galleon-2800hp-5-elite-soldier-1200hp"
    }}>{`Galleon 2800HP 5 Elite Soldier 1200HP`}</h4>
    <h5 {...{
      "id": "turn-1--2"
    }}>{`Turn 1 & 2`}</h5>
    <p>{`True Men`}</p>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <p>{`Striking Arrow`}</p>
    <p>{`Lym: "... If you don't stop...you'll make me cry too! Oh, I knew you'd come!" 1m35s before option.`}<br parentName="p"></br>{`
`}{`Miakis" You've GOT to be joking!" Option 1`}</p>
    <p>{`Miakis: "No, We have to save her!" 1m35s no input.`}</p>
    <h3 {...{
      "id": "castle-6"
    }}>{`Castle`}</h3>
    <p>{`Go to your room.`}<br parentName="p"></br>{`
`}{`Ferid: "Your Majesty! You can't mean..." `}<strong parentName="p">{`6 Minute Break`}</strong></p>
    <p>{`Galleon: "You may trust him with your life, Your Highness!" 1m45s no input.`}</p>
    <p>{`Go to infirmary. Go to tablet room.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-14"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Miakis: Entourage`}</li>
        <li parentName="ul">{`Zweig: Entourage`}</li>
        <li parentName="ul">{`Lorelai: Entourage`}</li>
      </ul>
    </Menu>
    <p>{`Go to War Room.`}<br parentName="p"></br>{`
`}{`Lucretia: "However, this decision is in His Highness' hands." `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to 1st floor. Talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[3U]`}{` Goesch`}</li>
        <li parentName="ul">{`[2D]`}{` Dinn`}</li>
        <li parentName="ul">{`[3D]`}{` Faylon`}</li>
      </ul>
    </Menu>
    <p>{`Go southeast to go outside for Galleon cutscene, Galleon to party.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Have to leave Castle for Logg (and Viki) trigger which requires fighting Byakuran.`}<br parentName="p"></br>{`
`}{`On PCSX2, going right and Mirroring is 1s faster. It is probably slower on PS2 though due to more loads. But you get the sick Snake Flight if you go right.`}</p>
    </blockquote>
    <h4 {...{
      "id": "byakuran"
    }}>{`Byakuran`}</h4>
    <p>{`Striking Arrow (should already be in formation)`}</p>
    <p>{`Right Path: Exit to WM, Mirror, exit 1st floor southeast, run southwest across bridge and follow path.`}<br parentName="p"></br>{`
`}{`Left Path: Run back downstairs, west, and refer to above. Run past Logg to the west, enter Ceras Lake Ruins screen and run back to Logg.`}</p>
    <p>{`Talk to Logg, select `}<strong parentName="p">{`Port Spinacks (1U)`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong></p>
    <h3 {...{
      "id": "port-spinacks"
    }}>{`Port Spinacks`}</h3>
    <p>{`South, up 2nd stairs, south slightly west. Talk to guy by save crystal near southwest exit. Backtrack to boat.`}<br parentName="p"></br>{`
`}{`Talk to Assistant Option 1, 1 Textbox `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong></p>
    <h3 {...{
      "id": "hershville-naval-base"
    }}>{`Hershville Naval Base`}</h3>
    <p>{`Northwest up stairs, pick top right chest for `}<strong parentName="p">{`Blinking Rune Pc`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Southwest down stairs, north west towards ramp, north east to Cathari.`}<br parentName="p"></br>{`
`}{`Talk to Cathari.`}<br parentName="p"></br>{`
`}{`Back to boat, talk to Assistant Option 1 Textbox `}<strong parentName="p">{`Option 2`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SKIP BOAT TRAVEL`}</strong></p>
    <h3 {...{
      "id": "port-spinacks-1"
    }}>{`Port Spinacks`}</h3>
    <p>{`Southwest up stairs, south, southeast, Cathari cutscene.`}<br parentName="p"></br>{`
`}{`After fade out & first option, Cathari: "I mean, a nice prince. Prince Hero." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Cathari to Entourage, then menu.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If not many fights taken in Doraat, consider moving SP off Hero. 2 should be enough.`}</p>
      </blockquote>
      <h5 {...{
        "id": "skills-equip"
      }}>{`Skills: Equip`}</h5>
      <ul>
        <li parentName="ul">{`Faylon: Slot 1 > Attack`}</li>
        <li parentName="ul">{`Cathari: Slot 1 > Attack`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Congratulations, you can run now! Hold L2 to run anytime Cathari is in your party.`}</strong></p>
    <p>{`Exit to the south east, Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-7"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room, talk to Lucretia.`}<br parentName="p"></br>{`
`}{`Cathari: "That is why I want to... assist you." `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to 1st floor, TP to `}<strong parentName="p">{`Port Spinacks (2U)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "port-spinacks-2"
    }}>{`Port Spinacks`}</h3>
    <p>{`Exit southeast to Worldmap`}</p>
    <h3 {...{
      "id": "world-map-13"
    }}>{`World Map`}</h3>
    <p>{`Southeast to Sauronix Castle`}</p>
    <h3 {...{
      "id": "sauronix-castle"
    }}>{`Sauronix Castle`}</h3>
    <p>{`Enter Castle. After cutscene talk to Combat Trainer.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "train-1"
      }}>{`Train`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Dinn`}</strong>{`, `}<strong parentName="li">{`Cathari`}</strong>{`, `}<strong parentName="li">{`Faylon`}</strong>{`: Attack - C`}</li>
      </ul>
    </Menu>
    <p>{`Exit Sauronix, run back to Port Spinacks.`}</p>
    <h3 {...{
      "id": "port-spinacks-3"
    }}>{`Port Spinacks`}</h3>
    <p>{`Talk to Item Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-4"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Goesch: 4 Jizos`}</li>
        <li parentName="ul">{`Dinn: 4 Jizos`}</li>
        <li parentName="ul">{`Cathari: 4 Jizos`}</li>
        <li parentName="ul">{`Faylon: 4 Jizos`}</li>
        <li parentName="ul">{`Inventory: 10 Jizos`}</li>
      </ul>
    </Menu>
    <p>{`Exit Spinacks to Southwest.`}</p>
    <h3 {...{
      "id": "world-map-14"
    }}>{`World Map`}</h3>
    <p>{`Head northwest above forest then west slightly south`}</p>
    <h3 {...{
      "id": "twilight-forest"
    }}>{`Twilight Forest`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/639590ca6fe25d6582097b1320e22710/01bf6/TwilightForest.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "111.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAACXBIWXMAAB7CAAAewgFu0HU+AAADqklEQVQ4y41VzW8aRxTfP663Xnqq1Eqt1EPUow+VIvUSWXJOSVq5aZrKdpsa02Cn/sLUGDBfyy4QwmK+DAaMAzaWwWDA2HzvLvw6u2s2LHDoW72d2ZnZ37z3e+/NUMPhEJJI7bhK0m63Ua3WUKvVcFuvQwSPW4aBzbCBlVU9rBYLeJ7X/E+NOoPBYEpHwDJ48xb6N0dw/fITrK+fwekw4rpYmjKGwv+UUi6LH79+jMXHj/Dihy+x/euCBmwklCDyqPWqSKQS4IIc4vE4fF4fgsEgAu8DuDg/VxenmHdYffI9dM/mkD+JyWOSJyORLeQHAhpo4TR3ihAXQjQSlYHD4TAYD4NcLq/+0LxrgTX9gfZ9TQWYbKkBIbWUSqFWqaByc4Obyg3qJADX19eokLFWq6Usljglj9e2gWajPsWdClgvl/Hk28/gcVjgctIw7e2BZVlsbm5iTaeTKVCtEIDAjlF1cxJM5nA4HMBq7yIUSsPvZ2W3JR2XgSjKrZldx5Z5ReVupoWkQZzwm0jk4POxiEVj5FuxqtftqKAxH40twyt0IWqCMCmUMjaYmjhL+uHe0YGzm+DY+BPcoRVip4OzKI1jnwOiIM4ElS2UKJFcEB9cu6uVEGaNcp/eWkUm8l7uZ478RBkkgx4kQvSD66K2UsbRR7uN51YywMBn3MTlSRJR69/w7q7BbV1D6So7M9JTlfKJYAVU6PdhWfkdJ143GsUsOq0mbOtLuLrIKPNCX3JSTS1qNtinHXkC2Lm/02watO/Kbee+iYSP1hhATYZd0cGDDjWpI/B9dJtt0LvrCLp3wZrfwLmzhojHCM6mQ/EsqwDOKvKR9Lpt9LtduX9VyGHhm8/xbvkpkpwTZULB3vLPqBTy6JMMsK8uKy6PzJWkWi7g6jyNRrWCTNiNZPQQnNMIr+UvnIRZZNJxFAtZdX2ZcMl5DDg99iIW2Ce1PBbR8IcDRIgmAi4CQKpieZ6cLnOo18qgt9/iMpvR8M3zPXmd12pA8SJNxkTFQlHg4TXr4fp3SY2YJJf5FPSL8+iQiokwbvyzuEC4W8c92UDOyzgD/+E25r/7Ah+TynFGlfM5WA1LOE8d4eI0CsakRyTsQOzVc5TsLvQewI9DPqSjfrD7Ovm78DEOl/El8WofJv1vaNSVI42a+8pDdqxoXBkOBSRDHF4+fwELuTfGaYl6DkHv6eA9MKDbbil5OH7AVisdBWTiHpHeFqsNB+YDFMfuDjn/Wnfyeq0Rytx/XXFV5alKU0sAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Twilight Forest Map",
            "title": "Twilight Forest Map",
            "src": "/static/639590ca6fe25d6582097b1320e22710/01bf6/TwilightForest.png",
            "srcSet": ["/static/639590ca6fe25d6582097b1320e22710/8ff5a/TwilightForest.png 240w", "/static/639590ca6fe25d6582097b1320e22710/01bf6/TwilightForest.png 270w"],
            "sizes": "(max-width: 270px) 100vw, 270px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Directions here are denoted using clock hand directions.`}</p>
    <ol>
      <li parentName="ol">{`North from savepoint, east at first fork. Hold northeast.`}</li>
      <li parentName="ol">{`After turn north hold northeast.`}</li>
      <li parentName="ol">{`Go south at fork, hold southeast to follow arc.`}</li>
      <li parentName="ol">{`At 6 o'clock go south. Go southeast > northeast around arc.`}</li>
      <li parentName="ol">{`At end of arc go north then northwest on next arc.`}</li>
      <li parentName="ol">{`At about 10 o'clock go northwest then west. Follow arc northwest.`}</li>
      <li parentName="ol">{`At about 10 o'clock go northwest to transistion to next arc.`}</li>
      <li parentName="ol">{`Go southwest, northwest, southwest again.`}</li>
      <li parentName="ol">{`Once you can go northwest, then go northeast and follow path.`}</li>
    </ol>
    <h3 {...{
      "id": "twilight-forest-ruins"
    }}>{`Twilight Forest Ruins`}</h3>
    <ol>
      <li parentName="ol">{`East at fork.`}</li>
      <li parentName="ol">{`South at fork.`}</li>
      <li parentName="ol">{`West at fork (grassy area & chest here as indicator).`}</li>
      <li parentName="ol">{`Go east then north at forks.`}</li>
      <li parentName="ol">{`Cutscene next screen. Pick up top chest for `}<strong parentName="li">{`Fujiwara Gauntlets`}</strong>{`.`}</li>
      <li parentName="ol">{`East at fork, then north at fork.`}</li>
      <li parentName="ol"><strong parentName="li">{`Pick chest for Golden Hammer`}</strong>{`. West at fork.`}</li>
      <li parentName="ol">{`East at fork then north at fork (savepoint).`}</li>
    </ol>
    <p>{`Zweig: "Give it a try, Prince." 45s no input.`}</p>
    <h4 {...{
      "id": "ancient-creeper-5000hp"
    }}>{`Ancient Creeper 5000HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`True Men does about 2750. Striking Arrow does ~330 less, want True Men to hit for ~2670 minimium.`}<br parentName="p"></br>{`
`}{`True Men, Striking Arrow.`}</p>
    </blockquote>
    <p>{`Miakis: "The Twilight Rune..." 2m30s no input.`}</p>
    <p>{`Escape Scroll, south to exit ruins. Then Escape Scroll again and south to leave forest. Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-8"
    }}>{`Castle`}</h3>
    <p>{`Go to infirmary. 1m30s no input.`}<br parentName="p"></br>{`
`}{`Go to 1st floor, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-all-to-entourage"
      }}>{`Party (All to entourage)`}</h5>
      <ul>
        <li parentName="ul">{`[2U]`}{` Goesch: Entourage`}</li>
        <li parentName="ul">{`[1D]`}{` Cathari: Entourage`}</li>
        <li parentName="ul">{`[3D]`}{` Faylon: Entourage`}</li>
        <li parentName="ul">{`[3D]`}{` Galleon: Entourage`}</li>
      </ul>
    </Menu>
    <p>{`Go to infirmary. Go to War Room.`}<br parentName="p"></br>{`
`}{`Exit War Room.`}<br parentName="p"></br>{`
`}{`Go to 1st floor, TP `}<strong parentName="p">{`Dwarf Camp (3D)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "dwarf-camp-1"
    }}>{`Dwarf Camp`}</h3>
    <p>{`Talk to Armor Shop owner.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-3"
      }}>{`Sell`}</h5>
      <p>{`Usual stuff. Want at least 171000 here.`}</p>
    </Menu>
    <p>{`Trigger scene with Wabon.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap-15"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`4 people from party for fighters from entourage.`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Talk to Dongo`}</strong>{`. Have to do it twice, sharpen weapon.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sharpen"
      }}>{`Sharpen`}</h5>
      <ul>
        <li parentName="ul">{`Cathari: 13`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Cart.`}</p>
    <h3 {...{
      "id": "tunnel"
    }}>{`Tunnel`}</h3>
    <h4 {...{
      "id": "2-assassins-2500hp"
    }}>{`2 Assassins 2500HP`}</h4>
    <p>{`True Men`}</p>
    <p>{`West to carts.`}</p>
    <h4 {...{
      "id": "raging-assassin-3500hp"
    }}>{`Raging Assassin 3500HP`}</h4>
    <p>{`Striking Arrow`}</p>
    <h3 {...{
      "id": "twilight-forest-1"
    }}>{`Twilight Forest`}</h3>
    <p>{`Exit Southwest. Head to Sauronix.`}</p>
    <h3 {...{
      "id": "world-map--port-spinacks--sauronix-castle"
    }}>{`World Map > Port Spinacks > Sauronix Castle`}</h3>
    <p>{`Watch cutscene, run back to Twilight Ruins`}</p>
    <h3 {...{
      "id": "world-map--port-spinacks--twilight-ruins"
    }}>{`World Map > Port Spinacks > Twilight Ruins`}</h3>
    <p>{`Cutscene, end up in Sauronix`}</p>
    <h3 {...{
      "id": "sauronix"
    }}>{`Sauronix`}</h3>
    <p>{`Go east, talk to Appraiser.`}</p>
    <Menu mdxType="Menu">
      <p>{`Appraise & Sell all`}</p>
    </Menu>
    <p>{`Talk to Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-9"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Crazed: Cathari`}</li>
      </ul>
    </Menu>
    <p>{`Enter Sauronix Castle, go to top floor.`}<br parentName="p"></br>{`
`}{`Go to Craig's Office, go all the way back downstairs.`}<br parentName="p"></br>{`
`}{`Go back to southwest, cutscene, Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-9"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room.`}</p>
    <p>{`Lucretia: "I'll dispatch the necessary troops. Which force will Your Highness take command of?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-lordlake-defense-campaign"
    }}>{`War Battle: Lordlake Defense Campaign`}</h4>
    <h5 {...{
      "id": "setup-3"
    }}>{`Setup`}</h5>
    <ul>
      <li parentName="ul">{`Zerase: Remove All`}</li>
      <li parentName="ul">{`Galleon: Remove All, Add Zerase (1U), Cathari (1R2D)`}</li>
    </ul>
    <p>{`All movements are with Zerase. Zerase is top right unit.`}</p>
    <h5 {...{
      "id": "strategy-5"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c76c7689bb85c490bd645a679ba2fad1/6af66/LordlakeDefenseCampaign.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADn0lEQVQ4yx2TeVOaZxTF+Uqd6QdoO9NOO007ydTJtGl1nNhGY4zRqMR9iwICLxIBEV52Ii5oKrjjkqDEDRGQRYwm06TTz/HrjX/cebZ5zj3n3Hs1x6kJpmd78EVHiM31sjzfy0q0n6WZLqKhduLydp7xcn7mZW2xm3l/K7P+FuYDT4h4W/DaHjHjqkN59hNvd1+gWYgZaNDeo6q5AbP5MfbRGgw9Veg6b2PormJSX02lEJIIYB/7lYG27zE8u8VQ63dYh+7R23YXc/WXWB/9xqpgaVJv7MRksxrXc5Cc4DBp5fXGGDtrOjaXhthZGeFk30k+FyA8eAtT3Rcoo1WYem9jHv6Dsa6fGW3+Bl3T1yRifWgyR26uimEq534+fVjgv3/jlHNhDjeMZLMqy68seJ0DWKxaJofuY+y4y+DzO5g6vmKu7xeshmph/QM9T75lKzaAJp/xcVkKk0u7KJ8HJMJkkjZcfTWo/qdMq+3YDU1Y9XVMmeuJqjqWnF1EDLUkLDVEI234JurpbPqRJamBppwL8u7i5Q1gKe/j4MjO4bGNjXWF+MY4m9Eu1twPSc1quUzoeb9jkXjB9a6DQs5PWbwtnAXYXDGLZVY0xYwqrPxkT6YoZj0i081uSmF1e5DlRD97x072MnaSSSPrL7WUKjN8/LRIpRzhouCjmHOTfuukJOCVQhBN4WSSSl4lfyqS836uhG2lGOT02EFa2BYKXq63Q2T3PKR3JjjdtJA5Ubm+mBbAAJflaQEN8U4SvL+cRZPc1ONxNBPyafG62gh4tAS8WhbnhwQ8zHXZQ0XY78QUwpNaovI+5+sURioXkviqMifKwqJSiJReolmPDaMbqMY23ojN2oRibMA49hDV1SHeBvlQkU/C8mDbRNjeLH35gK3FfrJH1hvQotQgm3aLZRJin+Z1QsGk+wunuYEpSyMu+aQorbgdLZwdT3FVDnN+5CB/aKaUtrErvbm/Lr35xkjuUCyQSculp8iequQ+AyYTJkwj97Hr/8Sml9X4AMX0iKCnndKZm4+VEOVTB+X0CwF0UEzbqWQdnKXGyewrcm/nH1FxKYW9KPrRJOIjPO/9/Ua2RVeLXlZltJYJpZEZfwd/z8j8hrREAp28ivTJuZ+4zHo03MVcQO5D3cSiw8QXhkntSdtsL4/isNTjlAi6Wm4K5P1cJPUpHnsTqv0xqpxt1lYiwX5mQwPSzEOSoJ+w2sm47SkuZzvTwV4SWyb+BxPGKIDubyfEAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Lordlake Defense Campaign",
            "title": "Lordlake Defense Campaign",
            "src": "/static/c76c7689bb85c490bd645a679ba2fad1/6af66/LordlakeDefenseCampaign.png",
            "srcSet": ["/static/c76c7689bb85c490bd645a679ba2fad1/8ff5a/LordlakeDefenseCampaign.png 240w", "/static/c76c7689bb85c490bd645a679ba2fad1/e85cb/LordlakeDefenseCampaign.png 480w", "/static/c76c7689bb85c490bd645a679ba2fad1/6af66/LordlakeDefenseCampaign.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move to P1`}</li>
      <li parentName="ol">{`Barrage Jiden.`}</li>
      <li parentName="ol">{`Star Rune Jiden. Should be in range when he's northish.`}</li>
    </ol>
    <h3 {...{
      "id": "castle-10"
    }}>{`Castle`}</h3>
    <h4 {...{
      "id": "extremely-important-option-here"
    }}>{`EXTREMELY IMPORTANT OPTION HERE`}</h4>
    <p>{`Lucretia: "What do you think, Your Highness?" `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Next 2 Options Option 1`}</p>
    <p>{`Gizel: "Is that so? I hope your faith is not misplaced." 1m10s no input.`}</p>
    <h4 {...{
      "id": "war-battle-final-defense-campaign-1"
    }}>{`War Battle: Final Defense Campaign 1`}</h4>
    <h5 {...{
      "id": "setup-4"
    }}>{`Setup`}</h5>
    <ul>
      <li parentName="ul">{`Zerase: Remove All`}</li>
      <li parentName="ul">{`Boz: Remove All, Add Zerase (2U), Talgeyl (X), Cathari (1R1D)`}</li>
      <li parentName="ul">{`Goesch: Remove All`}</li>
      <li parentName="ul">{`Bernadette: Remove All`}</li>
    </ul>
    <p>{`Can use R1 x2 to select Zerase`}</p>
    <h5 {...{
      "id": "strategy-6"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7e8c8773982d715d160a13cac66ce2bf/6af66/FinalDefenseCampaign1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADJklEQVQozw2NbVPaBgCA83/2Zbe7dd6q1lJIUSAFSiAEQnhLgEBCSEASQkQBCRZNeQ8IiICBk3Wdet31ttXZO+/2u8a358vzPEDt33tm1CP6LewD7zlNuEokWksjZdpbZT1dxXvZ8Na5YEMguyehpsxfqbmpWpiWKqt6XO8BpfsllmmFhL6gcDhjdxEgkrAicWvkEMVGKjnvEDn3gd/gCJkh3MQWo7KSa4a3mjEXOzkBiI4cGbWpxSWtd7DBMdoR0FYeU0V/Qwxf99OrUYODOPRHsuCl8p7McSKRRfEoGAwb+F4YyFb9V09j/fl6+H1+8XQjPv6WeFjRn/XIfEjqo+hyLBTIagqSSy5FcPeKeLrOv49DcMoeH5eAzpRY32W//lP561H5/qw+PA/4h3l4PY1/mmW+rNnP02SzXG7XKh/LqqbU8nAkY4mSL0nGmBJh4OQCrffwwZKZ32Wnt+zNimnPyrmbfuHThF5rgpKKLLTIwyqhqwlNDJyxOGPJnmJ5BYulHQAS2Ilxb1vj6PCSmgyys/7RrHm86Nams/Zw0DnXr46+LIZPK7ERp/JO+TzIV/3vCVMsbztqIECEMnKSlaDAi1P2dnh+01V07cNSO1uOz+9H2t299vjf8O9vZ2U1GMjsk4ItwLz1xV8rHd/6qwjg5N7Bu58c0I6QDMvZsJTFq1JcH9T1nnJ9eTi9Za7XrLag6KIdTZjogo2TbKGYgS+5eksasME/vzL+EMTNLO1gKIiJOfMZ36Jb1SdF/Xd+9afQuyKTvDnGmv2RV2HKEM+YqbyFLjlCvAXISGaSNnEyyouQKMNCxiky6EbuNtOlurt0BvOSLS1YyDSIhnaR8K6HfONLggkRQggjcKHhvIxIFW9WgviiMy85uZxNPvUluQM/sUfl9qOpN5v6Zk6kjBsOpUEsDiazEMFYgPaESh3CwrE/JzmZnI3m9+Hgthn5Zd+9ZQ9su6MmOLDnQLcdyK8W+wtPcBcmTPbAntW7496cb/84UVtUu59WeynlY7TSwHOywx18aUNeWJAtC2J45zd5oiZ3BMQoqzsEWoIghBkDlBUmjP8Da3J9TxHZB4cAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Final Defense Campaign 1",
            "title": "Final Defense Campaign 1",
            "src": "/static/7e8c8773982d715d160a13cac66ce2bf/6af66/FinalDefenseCampaign1.png",
            "srcSet": ["/static/7e8c8773982d715d160a13cac66ce2bf/8ff5a/FinalDefenseCampaign1.png 240w", "/static/7e8c8773982d715d160a13cac66ce2bf/e85cb/FinalDefenseCampaign1.png 480w", "/static/7e8c8773982d715d160a13cac66ce2bf/6af66/FinalDefenseCampaign1.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}{`1. Move to P1`}<br parentName="p"></br>{`
`}{`2. At coastline (right side of cursor square), move to 1 tile left/right of Jidan.`}<br parentName="p"></br>{`
`}{`3. Fight Jidan, Mother Earth Rune.`}<br parentName="p"></br>{`
`}{`4. Instantly after battle Star Rune.`}</p>
    <h3 {...{
      "id": "castle-11"
    }}>{`Castle`}</h3>
    <p>{`Raja: "It's a trap.", Lucretia: "That it is." `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "roy-vs-childerich-duel"
    }}>{`Roy vs Childerich Duel`}</h4>
    <p>{`Guard is ~1s faster than Special`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Deadlock, eh? Take all the time you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Deadlock, eh? Then let me break it!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't make me laugh! That pitiful...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't make me laugh! This is how you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Grrrrr...Damn you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha ha ha! Are you done?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha! There's more where that...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha... You start first.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha... You sure you're ready?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha...All right, here I come.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha...Allow me to reunite you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ha ha ha...Pathetic performances like..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hmph. Guess you're not as weak as you..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Me, Injured...? I'm gonna make you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Me, Injured...? You're not getting...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Why, you little brat!! Die!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Why, you little brat!! I'll put you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You tired already? Need a little break?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You tired already? What fun is that?!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`After last action 2m30s no input.`}</p>
    <h4 {...{
      "id": "war-battle-final-defense-campaign-2"
    }}>{`War Battle: Final Defense Campaign 2`}</h4>
    <p>{`No Setup. This fight is horrible if you mess up. Have to try to recover with other Dragonhorse unit.`}</p>
    <p>{`General strategy is to zigzag between ships to Childerich and lock him in bottom right corner. Want to make sure you attack him from top left, otherwise might get barraged by archers.`}</p>
    <p>{`R1 x4 to select Craig. All movements are Craig.`}</p>
    <h5 {...{
      "id": "strategy-7"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f5366d412555ebb8086de0af5e884368/6af66/FinalDefenseCampaign2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAADqElEQVQ4yx2T2VPaZxSG+Ys67bSdqTUxcUERFwTc+LEJioAIAiIuqCCygygSEFERN9S4jTGLzUybJl2mTS960T/o6Te5ODPn5jvn/d73OTJnUM1SIsD4rJGhsRa0Y61YVsdx7SQIHhWYLEUxn+1ibhxgKUbRrnlxlONMbK2KCn/pi/UwpeoChuIaMs+SBslbxBQsE4z5sQSMmLwSzgULU8ExvFEHc483mE4rDM0MIde1odC1orYo8K/acYec5MzfU7APok/NIzN5utBG/Lgb+8wIRZ5qipGkFykXYPGiQurtOcHHa/zv74msaJk3fcWkfwiLS4nkUmMVS8xjHVhFOUoRZB0OFZPXNfHgFum4iOW0iO+mhrVRYvpNg/g/v+G7P2Xm9SmRuJug+Rk2vxK7W87a3CjWJStdxi5UVgXOShxZTyKI7901U7dHmI/yjJ9sYj8r4L+p4rso49nbwHK5i66eJVBN4kksYIr6mBD22CNT2JJ+tF49aqeGkcQcMnUxhvvhHNerBtMXO3iuq3juhMLLEgu1HNElN2P1OL74FIajF0y/OsN6XMawt8VgMcVwIY4mE6ZvfR5VahmZZnPlyzDHyz18V3u4hCrzUQ7b1Q6u/Tzx2DzJ8zrBapbR/Q2MhwVMh0Wkco6B1ArdkQBKUb1i4GB+HVm3w8jEWQXnSZHlt5dMX1Ux19I47/ZZvtgjm4sSur1i4fYU+7lIupJGLxZJu3lGxVBNPkp/IsRAZhVDNY/sx55O2hwGhrOCsUyEgbCfvuAkA+lFgiclNnIxPB/ucd0dYz4tIx3k0QmlhoOCULst1G6h280hVTcx1baRNfd18by3lX63mcFVH9oVH3KvDbno/fUisdgS3l8eSPz5M+FPjzhv6oyfV5l8ecDYSQFdTWBWSWKobaEpiC+3DbTT1vOEDrWcjkkd/Ytu5A4T3UEXM0LFenQRh+BwXsCd/fyJ9N8fmf3pVlzPNlI9g7YaRlUMCX9T6EWIMsOUkg7NU7oHn9BrUdIZcPDUZUMRmmXx5pi48HDz39/Z+e8z0b8+sPbHe1Y+vmH51we8786QGhn051mG6wn0IkyZfrqDlt5vae7+Grn6OzoN7TTbdMgDTowv0uJiohgFFtaNCKZsiCFhvnG3gPVgB7MIQZVfRpUVyKTnBEoZgY31Gb1SE/3DTfQN/UBb/zcodc0oRppQinMatMvFFbSjGH6OarQFX3ic5fIaucMkCwJ0TTKEtBHFUkhiOyzxP7ClpEP9NMCVAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Final Defense Campaign 2",
            "title": "Final Defense Campaign 2",
            "src": "/static/f5366d412555ebb8086de0af5e884368/6af66/FinalDefenseCampaign2.png",
            "srcSet": ["/static/f5366d412555ebb8086de0af5e884368/8ff5a/FinalDefenseCampaign2.png 240w", "/static/f5366d412555ebb8086de0af5e884368/e85cb/FinalDefenseCampaign2.png 480w", "/static/f5366d412555ebb8086de0af5e884368/6af66/FinalDefenseCampaign2.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move to P1 (directly down right, vertically aligned with Childerich)`}</li>
      <li parentName="ol">{`At red line, about 1-1.5 tiles left of Childerich go to tile 1 above 1 left of Childerich.`}</li>
      <li parentName="ol">{`When close to Childerich, target him or tiles below him.`}</li>
    </ol>
    <h3 {...{
      "id": "castle-12"
    }}>{`Castle`}</h3>
    <p>{`Northeast, enter castle from left side. Go to War Room.`}</p>
    <p><strong parentName="p">{`After Shula Valya and Castle cutscene only mash Triangle!`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Somehow the war battle selection is completely lagless. I have now selected the wrong one twice.`}</strong></p>
    <p>{`Raja: "We've got the upper hand now. I bet..." 3 Textboxes`}<br parentName="p"></br>{`
`}<em parentName="p">{`3 Lucretia Textboxes, then`}</em><br parentName="p"></br>{`
`}{`Lucretia: "Who would you rather fight, Your Highness?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "war-battle-armes-pursuit-battle"
    }}>{`War Battle: Armes Pursuit Battle`}</h4>
    <p>{`No Setup`}</p>
    <p>{`Prince movement only`}</p>
    <h5 {...{
      "id": "strategy-8"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/57e0e46cf44b8611b9db993bc79d6609/6af66/ArmesPursuitBattle1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADnUlEQVQ4yx2TW1NaZxSG+TG9amu0pvGAqIggREUBYbthc5CNILjZgKDiGYGAYoxJSEajNLUxKo7T1LQzmabTTmd61Zv+p6dfvFjzXXyznnfNu9ZrCGa8qEUFXyFMYMHJTNiGSzHjCpmQolZCSQdS0kZYH8EfeUhY6WNHl6gvB9kvzpGLO9AzPSxqj1grSBh8+jjZzTDebBJ10UskMIjX08nMdAez7i4UqYuwNkgibUVxfYvqesSSYkGb7aOSc7ErBnke6eVlSkbXpwQwMYpvYYyQ9hhfbISpkJFx+Xs8oT6kOSPRpAklOUAqM0k1YWZV7qKo2cjHTGTVYdYTDlYVE2lvF4mU8QvQgmfegrxoQ8k6mFmw4klYCeh2ZM1OUHcIMTMh3SSax2iuz1JeH+esYKeVnqCYchOf6ccz+RVBtQdD7VWA+LIDb9wimu33b0iAo0sTSAIuL46hCLGIAB7UJT7dVLl9s8JvRyl+3ZM4aUY5qsrslZ3kilYMb281mucqSyWngJmZTVmFBRYiOTvqkoDpVqSUmcbaY963czTfzvPkyM95q8SH9nPu2nX++LzPX3/v8enPMobinkq2FGbjIIq+PYu+JRPNuymUfZxdpWleLNJqFri72aV1nReTDuOPD7C65uP02RbvmjV+ala4Oq3wsX2IQdbcKJqTSHaa+WU34ewU63WZk3cp2ndF/vn3Bf/93uRdewW9NE04PUIkPUwgNkh1O0H7TYP3x3Xap0+5PK5hiOftxLMWZsRWZ1UTTn8v+soEz17F+Pi5yuUvG+w9lclsCF8zI0ixfmKxMV5W8py/2BWwMjc/lrg6E9Mer2C4Fsq71RC1A5VKLUS54mdzx8/Suk9YMEMwM4aUGGZON5NateFfGCCXdXP5usxFc5ebVo3r1iYv9+Kcvy5g2D8Q165NoBWm0fJT6PkJcciTjHr68KfEKSWHiWhDSHGjSI4RT7AXNWemsObmVWOVq5MGHy6+VJ3b8ycYpkTE7NMPsbm6GZ3qxuL8TsCM98BwZlQAB/FFBkhrLmpr89RFzSVHxWL6Oarp/PzDITdnDeFhQyynimFc7qHf9uC++ka/Zmy6k+HxDgbt34hMPxJCDwjJNirLixzu5NheiRJQzfjmBgjPj6BlZOpbSzS2c7QOSxiCCyYcnm4m5V4SYqKNXQ/Lm05k1YhlskP8dRJQRtBTYXIZBY9/SMAGCYnUeENDBObclIpp6hsZqqUF/gcgIm0lsDrJPQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Armes Pursuit Battle 1",
            "title": "Armes Pursuit Battle 1",
            "src": "/static/57e0e46cf44b8611b9db993bc79d6609/6af66/ArmesPursuitBattle1.png",
            "srcSet": ["/static/57e0e46cf44b8611b9db993bc79d6609/8ff5a/ArmesPursuitBattle1.png 240w", "/static/57e0e46cf44b8611b9db993bc79d6609/e85cb/ArmesPursuitBattle1.png 480w", "/static/57e0e46cf44b8611b9db993bc79d6609/6af66/ArmesPursuitBattle1.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f57bd36723aac7f43cec629aa6e5b03b/6af66/ArmesPursuitBattle2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADeElEQVQ4yx2SW2/iVhSF+R+t1KpVq2ZyD0kcDBiwsY0xdwg4QLiYOyaE3IZJJpnJRVFTVXNRZ0ZqR30YqVIfK/UP9K99PcnD1t5HOmedtddavsPTHPd3Hpd3x7y79Xjzasi71x6vThwarvRU7YMorUmESkOi5gYp1bap1NZp93Zwan6GAz831wbTkxw+x1PxzmuUDkdczrvcTHaZd23mrsWwHKbprON0ZcqdEHvlJRLatyTVb8jqX9OpSnSbKu9b27wfOby4qgrAXhBvUuLjL3O+fLhmfpajNwwym9ocTZJ0xVwdBCkOVA4EK6/4I5OxhNf30237aVVW2E99T7+4wNvfHHz9kcHnhzP+/njDw/2AsxsHdxanMVFozTSahxqNqU59ZvLSS/L5ps7Pdyn+PNf541jDdQMY6lfkU9/REkx9xVaGh9sZ11dTKm6C+kjj9LWDd5HHGWo4Y53aJEGpG2MwsPj0ZsbDZZ33R2nu3U2q9fUnpi9faLz9UMOn7qaJ5DNIVgKlmEctJyj2YkyuagzmZcHOpNRTSe0rVITeVWFQexZhzwtR6ASZnOp8+tLhr3+O+Pe/a3xWM0bK1QVYDCllsmloRMsK6bbC+MKhc1wiXg/R74WYjg0czxBbKOz1w7jjGN6pyfw2L0D7/Pp7E19FXKjOEthuFNURv7phSh2FVF3GrGyLdU2OZzUOTiuczPO0h1EBFGY4VegMQrREjPZbO3jPdYbP4/jKYh0luU7IWkGxl0kUVomnl9BzqziClXsc5WKc43CaFaVzNo1wImrmRRiJhBxPowyEsWVBojaM4LOrQaTYApq9hJlZIRT/CVlbQC8IdqMYjbEiNJQ5nUVxRo/bpCmOLApDm2zfwqhrxJwC4WyCRCODryTEViKLWHlZMJOIWGtoBQVzV6Y6VtkVwj8ac36m4wwMdocWqaaG3dBJ7GeIFCwixQyynSScTwuXCzLb0WXCtsyassOS7GdbD6KkA+Khgd3KUheAI6FzZRjHaiSI7xlC7xw7VpJYKUtUVCCZfOq+UFblWWCZjfAWm5EAq4Et1uUtFnf8bKhh/HHhfiJAKKMTy6sEbZ0tkQTJjCPFRU+aYtYJpUXs8il8j4eVkMwzSWItGmJZzD/4/SzIkugbLGxvsaoE2VR1gqbFVjT2BCabJkFNZ1Gc/UacoGGwY5v8D5wfLEDTKf/vAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Armes Pursuit Battle 2",
            "title": "Armes Pursuit Battle 2",
            "src": "/static/f57bd36723aac7f43cec629aa6e5b03b/6af66/ArmesPursuitBattle2.png",
            "srcSet": ["/static/f57bd36723aac7f43cec629aa6e5b03b/8ff5a/ArmesPursuitBattle2.png 240w", "/static/f57bd36723aac7f43cec629aa6e5b03b/e85cb/ArmesPursuitBattle2.png 480w", "/static/f57bd36723aac7f43cec629aa6e5b03b/6af66/ArmesPursuitBattle2.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/eff3c8e116509cd2515e04aafd9d25ff/6af66/ArmesPursuitBattle3.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADxUlEQVQ4yxWTa1MSeBSH+TJtjmuSIaCgiOAlTEIEQfAGCALKJRUlvCbiquVds1CXMbVVM8vW2tpbthedndF2Z9p8Uzu7O7Mf5Nl/L86cd895zvnNkdhbi2kJ6zEHy6m15dHsVjI8ep3bM3a+zHTw9Ek/33w/ysHeCDd9VSykXBxsD3BnsJlb3fUMdtoZ6TWxmGpgfNiHxN6uI9zXhCUcIBgyEXYX09WhpT92ld5IOdOpOt6fP+Dtb6v0BXT4zHmi5DivXiLsMdAbqmPOrWCqzcpQwoVkPtPK8JSDthuVtPiLiA8auD1nYzHdROZhgMxWgJ+P5/n4YZcHE/X02C4R9WkIN8oZEdvFGlR02eT0OJRMCGvJzKqL9FftxEbNNARLcPp1uNvL8HZUMr7gY+dFnBdHSU7/WOPRUpR0qoXxsRo2E+UcREq45dNzw64g3KRmMOZA4olq8YgbNvk1NAtgbMBCOGYmOeViOd3J4YtJzk+WOf9pkTebwxw/GONgopNHyTZ2E2YSURPJuJX1JR/r6QgSV0hLvUdFd/817m942Xnew/ZhP89eJzk5W+D8fIu/3m7w3+4XbM92cbgxxMnLae4OOEkNBpkci5K5O8je1hhHP8wicXqLCUT1JJIm5lZbWdsOcXcjwNazOPuvhljLJHiyP8GHl7M8zAxx9OYef/66yb4ApEc6SM/EWZ1LkBTw6clOYSgSbRRQp1uNv7OMnlEjrZEyGj3lRHprmEv7mV0Osb09xPPNAc6OM/z99Tr/vF7lF2G6sTTAggCNDge4N92D5Fq9gtJqKaVGGfrqXCprctEaciirklLnFCkOGZnJeLm/5OfHvSTvf9/i38eTfFzp51jYpmduMp4MM5EKMT0RRWJwasgvySGvRMnnCilynQx5aS4Vxss4vSrcEa1IXk08ZWX/u0mefjvPy1fznB6v8O50lR1hfX+xm3lhuXwnhqTCoueKLIdspZwrxSqU+mIuazVoqkswufXYvWqsrRrcAy6iU920Cwtn3IW3r5Wd/XHena2w+3iY1FwXI59umK/XIS2UczFfJkzVSNVKLsg1FJRq0dlqKXcaaOpz40124B1txz8Wwtnrwhi04ehtJj4dJTJ1g/apTpr6xevJ9KVkF+STJZch06qQFSu5pJKTp1JwWVNEofHTn9dhCTqoDdqxhhxUNZswNF/HHLAJcD3WsBOr6JaOeiTSIg3ZKiVZCgU56kKylAouFsi5IIw/E0OyBVxaWojGbKDCYaSktgydtRJD43VqPBa0DSYqRJk9dRi9Fv4H8ZCD8qhQA4gAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Armes Pursuit Battle 3",
            "title": "Armes Pursuit Battle 3",
            "src": "/static/eff3c8e116509cd2515e04aafd9d25ff/6af66/ArmesPursuitBattle3.png",
            "srcSet": ["/static/eff3c8e116509cd2515e04aafd9d25ff/8ff5a/ArmesPursuitBattle3.png 240w", "/static/eff3c8e116509cd2515e04aafd9d25ff/e85cb/ArmesPursuitBattle3.png 480w", "/static/eff3c8e116509cd2515e04aafd9d25ff/6af66/ArmesPursuitBattle3.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}{`2. When Prince is on road, move to P2`}<br parentName="p"></br>{`
`}{`3. Right before you reach P2, move to P1 in 3rd image (want to be standing on orange horizontal line).`}<br parentName="p"></br>{`
`}{`4. When the archer turns south you past it to the right, move to P2 in 3rd image.`}<br parentName="p"></br>{`
`}{`5. Once about horizontally even with archer, move to P3 in 3rd image.`}</p>
    <h3 {...{
      "id": "sable-2"
    }}>{`Sable`}</h3>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Can optionally bring Wabon and Georg`}<br parentName="p"></br>{`
`}{`Wabon guarantees kill with non main damage dealer stun, with both 1 main damage dealer can get stunned and still kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "party-6"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1U]`}{` Goesch`}</li>
        <li parentName="ul">{`[1D]`}{` Cathari`}</li>
        <li parentName="ul">{`[3D]`}{` Faylon`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Can still get battle in inn, doesn't work to try to skip battle.`}</p>
    </blockquote>
    <p>{`Jidan: "No one makes a fool of General Jidan Guisu!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "jidan-3500hp-5-armes-bodyguard-2000hp"
    }}>{`Jidan 3500HP 5 Armes Bodyguard 2000HP`}</h4>
    <p>{`True Men`}</p>
    <h3 {...{
      "id": "castle-13"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room.`}<br parentName="p"></br>{`
`}{`Lucretia: "What do you think, Your Highness?" `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to 1st floor, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
[1D] Cathari: Entourage (faster, doesn't matter)
    </Menu>
    <p>{`TP to `}<strong parentName="p">{`Yashuna Village (1R1U)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "yashuna-village-1"
    }}>{`Yashuna Village`}</h3>
    <p>{`Northeast to inn. Upstairs, southeast room.`}<br parentName="p"></br>{`
`}{`Cius: "Your Highness, allow me to go first!" 55s no input.`}<br parentName="p"></br>{`
`}{`Leave town & Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-14"
    }}>{`Castle`}</h3>
    <p>{`Go to War Room.`}</p>
    <h4 {...{
      "id": "war-battle-stormfist-siege"
    }}>{`War Battle: Stormfist Siege`}</h4>
    <p>{`No Setup`}</p>
    <p>{`Prince moves only.`}</p>
    <h5 {...{
      "id": "strategy-9"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/26f3f44bb6d02354ae47c29ce4453d4c/6af66/StormfistSiege.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADtUlEQVQ4yy2TaVOaZxSG39/SbdLEOJqk7tW6YNzGqNUEFxYFNxYVREEFBJRXBJRFKKAxbqiAmmpSk7bqGJf4oX/q6judfjhzzvPlOve5536EqfMM7uMMMwdppneiLKUDZA9siPYehhUyjncmubkPkTufZy3Zz0q4l9U1BcFIHwvBbma9XbiWWnD7WllYUyEEY6v0jIWQjweYNvdhN3QiWjvwTDZj0VbgmmkkuW8kuK5hTFeKXluEUVvCoLKQaVMjExOthNRFREbl2Hy9CH6vB4fdjs1qQXRN43Xa8C+Ycc70YhhvZyWmoN/ciFwvw6R8hk1dgNFYxtDgCwY0Rei00hJFIYa+QmbFDoRJxwCLTgdB0UPu8JCriytOP26TO/Ew69MwuSine6SWpYSK1JKSpENOONBFylZPWF/FqKEaeXc+avUzRs31CM5FMwvzLqLRGFubWxyms+ymI1zeBZha7EQ+WktoQ8u7IwNvUzpO992k42b2RRUb9kasnlbGLHUMDJUilywS1sIRfN4lfOIykVAUu3OKdNbFpyuRxK6B1K6OzKcptlMSINwjgUfYOdGx/buR7VMTW8cTxDMmVrcNrKzrEOyzQ8RiEiTtZm/Xw+K8hnc7Zm4fgtx+DXP/zxoPf4W4/jPE3V2E2/tV/r7ycn3j48vdMpdSv7wJcHGzQvbMiTBqacfk6kBcVhNbN7C7ZyBzOv5/TXDxEOH6c4KTP9xsns2ROrKSzE0ROzSTPJomnrUQlWb/tp4xKUJCc18JlbICKque0ztQg3tFiXPxNQtSBHIHZg6yVvY+zrN5NMt6zsFaxko8Zye4Y8IRV+FJDeJOavC+HSZ6YEL4VV1Gyc8/0lj/E+0vy2h7VUpTVzGW2T72I3pifhXBrWEs852Y7J3E0xP8lpnEt6WXQFrEjWESksL06RzvP3sQGl6/oLDyO+qa8mmozqOl/imylgK6lDL8QSWRzVFUulo61eW80VSwFFP9F/SUBM59cLJ7NIMY0XJx4efL9QpCk7yI0vLvqXyZR1ntY+n8PMprHlNe9QPOiFLyaJz5gFxS+ApX4A2bmTH2sibOPzj4erOKN6qRQl+LWcrr/pkDQdb2nIKibyipekTJL4/IL/6WfOld3fCEAUsTFrEbd1jyKqCW/q7U/Qr80ryZlMBbNto0Mmo6iukerkGU1Au9g5X062po6y6hvO4JFQ1PaeuvQGVuYsjWxoipGau2Fo97hHhikkTCTHDVSChiYk7UoJjuQmvtYsarwBtW8C+neKNoOky05QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Stormfist Siege",
            "title": "Stormfist Siege",
            "src": "/static/26f3f44bb6d02354ae47c29ce4453d4c/6af66/StormfistSiege.png",
            "srcSet": ["/static/26f3f44bb6d02354ae47c29ce4453d4c/8ff5a/StormfistSiege.png 240w", "/static/26f3f44bb6d02354ae47c29ce4453d4c/e85cb/StormfistSiege.png 480w", "/static/26f3f44bb6d02354ae47c29ce4453d4c/6af66/StormfistSiege.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move to P1 (directly up left)`}</li>
      <li parentName="ol">{`[Shoon]`}{` When Cavalry gets close to Shoon, move 4-5 tiles southwest.`}</li>
      <li parentName="ol">{`When almost at P1, move to P2 (2 right 2 up)`}</li>
      <li parentName="ol">{`When about halfway point between P1 & P2 move to P3`}</li>
    </ol>
    <h3 {...{
      "id": "western-woods--stormfist"
    }}>{`Western Woods > Stormfist`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-7"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Cathari: Party`}</li>
        <li parentName="ul">{`[1U]`}{` Goesch: Party`}</li>
        <li parentName="ul">{`[2D]`}{` Dinn: Entourage`}</li>
        <li parentName="ul">{`[3D]`}{` Faylon: Entourage`}</li>
      </ul>
      <p>{`Once you regain control.`}</p>
      <h5 {...{
        "id": "swap-16"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Zerase > Faylon`}</li>
        <li parentName="ul">{`Shoon > Dinn`}</li>
      </ul>
      <h5 {...{
        "id": "equip-10"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Goesch, Faylon, Dinn, Cathari: 4 Jizos`}</li>
      </ul>
    </Menu>
    <p>{`Head through Underground Passage. In Basement go south through broken cell door and upstairs to Infirmary. From infirmary go to Arena. As soon as you enter Arena 1m40s no input.`}</p>
    <h4 {...{
      "id": "hero-vs-childerich"
    }}>{`Hero vs Childerich`}</h4>
    <p>{`Special is .6s faster than Guard. Care for Super after 50%.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gah!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gaaaahh!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special / Super`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gunh Gunh Gunh Gunh...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Northeast, up stairs to next screen. On entrance, don't go too far down or you'll trigger Zerase text. Northeast to Godwin Castle.`}</p>
    <h5 {...{
      "id": "dilber-3800hp--4-imperial-guard-2000hp"
    }}>{`Dilber 3800HP & 4 Imperial Guard 2000HP`}</h5>
    <p>{`True Men`}</p>
    <p>{`1m25s no input after battle. Go northeast and enter Castle.`}</p>
    <h3 {...{
      "id": "godwin-castle"
    }}>{`Godwin Castle`}</h3>
    <p>{`If battle True Men.`}</p>
    <ol>
      <li parentName="ol">{`West at fork and follow Red Carpet. Northeast at fork, go upstairs.`}</li>
      <li parentName="ol">{`Southwest, 2nd door (Gizel's Room)`}</li>
    </ol>
    <p>{`Sialeeds: "Oh by the way, is Lyon okay?" Option 1`}</p>
    <h4 {...{
      "id": "sialeeds-3500hp"
    }}>{`Sialeeds 3500HP`}</h4>
    <p>{`Striking Arrow`}</p>
    <p>{`After EXP Screen 1m30 no input.`}<br parentName="p"></br>{`
`}{`Go back downstairs, east to trigger cutscene.`}</p>
    <p>{`Go up east stairs then first east door. Cutscene, then back downstairs.`}</p>
    <h3 {...{
      "id": "castle-15"
    }}>{`Castle`}</h3>
    <p>{`Go to 1st floor, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-partyentourage-doesnt-matter"
      }}>{`Party (Party/Entourage doesn't matter)`}</h5>
      <ul>
        <li parentName="ul">{`[1U]`}{` Galleon`}</li>
        <li parentName="ul">{`[1U]`}{` Georg`}</li>
        <li parentName="ul">{`[1D]`}{` Cathari`}</li>
        <li parentName="ul">{`[2D]`}{` Dinn`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Lelcar (1R1D)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "lelcar-2"
    }}>{`Lelcar`}</h3>
    <p>{`Southwest to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-4"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`All Party Items EXCEPT Jizos, Blinking Rune Pcs, Crazed, and Firefly`}</li>
      </ul>
      <h5 {...{
        "id": "buy-5"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`4 Jizos for all in party`}</li>
        <li parentName="ul">{`Jizos to Party Items until 10`}</li>
      </ul>
    </Menu>
    <p>{`Go Southwest to Western Islet, then Northwest for Rune Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-6"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Double-Edged Orb`}</li>
      </ul>
      <h5 {...{
        "id": "equip-11"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Double-Edged: Georg, Goesch, Dinn`}</li>
        <li parentName="ul">{`Firefly: Galleon`}</li>
      </ul>
    </Menu>
    <p>{`Go slightly soutwest then northwest to exit Lelcar & Blinking Mirror.`}</p>
    <h3 {...{
      "id": "castle-16"
    }}>{`Castle`}</h3>
    <p>{`Go to Prince's Room, 2m5s no input.`}<br parentName="p"></br>{`
`}{`Go to War Room.`}</p>
    <p>{`Go to infirmary.`}<br parentName="p"></br>{`
`}{`Silva: "I guess I'll check on my other patients." 1m no input.`}</p>
    <p>{`Go back to 1st floor, exit building southeast. Go southwest across bridge for Georg cutscene.`}</p>
    <p>{`Go back, up west stair then east entrance.`}<br parentName="p"></br>{`
`}{`Talk to maid by your room. 1 Textbox, `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to War Room.`}<br parentName="p"></br>{`
`}{`Raja: "It'll be my pleasure to deliver the first blow!" 1m5s before Option.`}<br parentName="p"></br>{`
`}{`Lucretia: "If you would, Prince?" Option 1`}</p>
    <h4 {...{
      "id": "war-battle-sol-falena-siege-part-1"
    }}>{`War Battle: Sol-Falena Siege Part 1`}</h4>
    <p>{`No Setup`}</p>
    <p>{`Only move Dahak.`}</p>
    <h5 {...{
      "id": "strategy-10"
    }}>{`Strategy`}</h5>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/605a24c422f7c9bcd175b1a69fc4fb0c/6af66/SolFalenaSiege1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADq0lEQVQ4yxWUWVPiVxDF/58qz3lKVSqpSUbHTFR0BAHZVwVxA2UQQXHFjICICCKuiCAg4oprdGJNRmcqk0xVkodUvsUvNw9d1X2r7+nTp/teqb+QxbocQBEeoG1+GENyCnNqlom9VULCxsvrhJ8eCL27Yyi/gjUVpjMWQLsUwrwyiyoSwJbwYF8expjPIPXHx6llR1lbcmPxmnD4rNiGtAz77Rj6VVh8BmYf3zLx/h6T30STroFm4w80G16gH1ChHdQx2fEF06oGlIlpJN/dOaHaDr2iunl7CfPmIuaNKC4RWzZiGDaj2M5KOG5OcPs1WPVfYxzsQN3bQnuPDGW3DL31JRr9d6gSQaRekej4+Rz77RmdxwW6hKmP8hgEyP+mOy3RU69iuarhDtgIar4hPqki7nnBZF8rBnEmcyl5bmpEvhhA6qmXcdQPUB9so6nu0La7jLyQ4tVeElkugVJoaDkpYj8v4hS6hRb8JLMxspFRkm8GcCb86MMjqCZ7UayGkVQHG3Tur6Iub9AlQDuKGTSVdZT7GVpyS7QX02hrWwyH+1Dm0thujwkIPac+vSfx12cSnz4w8us9fXcXqKu7SLqTXWSCkaK0hkIw1J9V6b2pC82OUdW2RVzEX64wup/HtZsRbPfpvTpm6PaU8YcbVv74yMJvjzivT9AKuaRB4eiEZhbRtuf2iMhdjuRDkeDlIY7SDoarQwb3i7jrh/QI8P7rI7z3F/jeXjLz9AtTHx7oE3PoquVRig4lez7Hj3MhXi3MMBodYmJGzti8Bq/fRXAlTvdFFaNgbqpsYhAy2CpbWE8LOOslfPd1xh6u6T4roz3cQS2kkgzrGb73DtHmc9HnlePxtTIwKsfg7safTjC5kSZe3iNSzjOSjTOYDNO1l0JeWsV0nEN/tIvtvIKxlkMrCkrK7CoNvmGaxrw0eRwYx+yoRm20inissE30qELy80divz/huj5EWV2nXWyAqiSGV92ks7KBTrSrEB10FNJI6s20AHTTEnTT6PfwMuilecyDLORn5PGO1X//ZuufP3n9cInxfA/FQZYWAWgQa+S6O+X1uxssl1WxrwX0x3tIslSUL51mvnJZ+dbt5Ll3gGceF8+GnMiXI3RvZhgp7GDPptFkltCuxWl8M05LfE68rDU8xTw2kaNKL6IviaEotlI0TgdonBun+acpmuZDNAi/KRyieSZIZySMMRHDGI3iXEvjWFvBlIqjS8boSkTEHfFBLMUwp5fpPyrzH0lz+XtygNiSAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Sol-Falena Siege 1",
            "title": "Sol-Falena Siege 1",
            "src": "/static/605a24c422f7c9bcd175b1a69fc4fb0c/6af66/SolFalenaSiege1.png",
            "srcSet": ["/static/605a24c422f7c9bcd175b1a69fc4fb0c/8ff5a/SolFalenaSiege1.png 240w", "/static/605a24c422f7c9bcd175b1a69fc4fb0c/e85cb/SolFalenaSiege1.png 480w", "/static/605a24c422f7c9bcd175b1a69fc4fb0c/6af66/SolFalenaSiege1.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span><br parentName="p"></br>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ad91876d2551abbff7ca5ee81b2d2ed3/6af66/SolFalenaSiege2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADuElEQVQ4yw2TWVNaCRBG76+a95mq1CRmKiajBpdoRAQXXLBURMSgyCKrgKzKBa+yuKFoCGRckriOcdTEuCROMstDnuZPnLkPXdVV3fXV6a+7hZV8lrTowR1xUu+00uh30zTlQhXx0xoP0C6GUa0XUS+vMdSjROc0oZuxYLGrsdmUBOJavOE6XEEFE5EWhKQYYCtroSCasQ+30afXoOhtQm3Q0Dqkpl6vomWjhNFhpaPlPk26Wh62PqKm4zGjY81MmJUElT8wpXlKdH4IIZ/PMZcKkUqGmJ0JEAm56fNN8tjjoi7oQ5lKYHS76DcPywIyYecDVIMKqrseUdVdTXNPFUpNBa1tDzEsOBHcYpJXxU2WNwpkV5ZIL+aQshlC+XXSb9/hTSUZGNETfL+P3aPH1vozMbeSkPEX7HoFSksnT3rreKpT0Cr5Ee7ZPDKRn0xaIp1LI87PUSwXWc2vkFvM4pUSxI/2sN1cMJj0Eow7mUr6iAdMBPsqGQgNo50eoz8yjm5DQqgIJ/jJFUBldRCXUmztbrMki8VSIlExQSyTRcrEMCad9J8eYvh4jPrtJrrTfZIfT0hfHDH99QbH9RlDx7sI6vxLqnN5fvSFcbrdbG6VEWWyuXmJmQWJxPoq89MRQhkR43YBQ8JLR2mRgYMy0t93rH7/F9f1BYbTPbRvXiJ0lrbRRuIMDA1gGhthJr1AOL/MzOoS0k6Zsb3XSMenxM5P6CzmaA++QDvnoW13HdPxDvazA6wfTpi4PKV7r4TQreum5Xkt2lE9fbNR2hxjjIybGZLPpGt7g4nzY2LfbtDJRF2/rfD8VZZnayLtW8toyjlaShn0srD7+hzjyTuEHp+DLreVJr+HBxYzVY5RKns7aR7WM3l2ROjmA77bTwwe7dBQkOiRx9WUF+ncLdC+k2f89C3Ttx8Qv94SvbtCMJQ3eeayUuucoMZuRumxonDZaYyFMOy/YWCrhG09Q9frDVSlJRR52cv9Mub37xg/OyT91xdSf94Q/fyJ5LdbhOYliQfjRmplytpJC48dFmosL+hw2PBeXTL9+Yb473uMHu4wfH6Adr/E4Mku4S+XJOSlvPrvO6l/7nBc/SH3nyHULcS5Z+znybiJCrOR+3IoXozQrGrAKi/H+7qEqbjBoJxbigU02RQt6QTtuTkMazlMhVWMhRU0adnXl0sIynyaX4MuKgOTVHgsVE+7Uc/N0j0v0paI0pOaoSHso8HvRSsfuToZoz7qpzHup1l+1dqghya53hidQrU6z//BRvQS2UwMpgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Sol-Falena Siege 2",
            "title": "Sol-Falena Siege 2",
            "src": "/static/ad91876d2551abbff7ca5ee81b2d2ed3/6af66/SolFalenaSiege2.png",
            "srcSet": ["/static/ad91876d2551abbff7ca5ee81b2d2ed3/8ff5a/SolFalenaSiege2.png 240w", "/static/ad91876d2551abbff7ca5ee81b2d2ed3/e85cb/SolFalenaSiege2.png 480w", "/static/ad91876d2551abbff7ca5ee81b2d2ed3/6af66/SolFalenaSiege2.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Move to P1.`}</li>
      <li parentName="ol">{`When close to / at P1 move to P2. No harm in waiting for Dahak to stop moving if you want to be safe.`}</li>
    </ol>
    <h3 {...{
      "id": "dahak"
    }}>{`Dahak`}</h3>
    <p>{`Go east, down stairs. Talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-8"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1R]`}{` Goesch`}</li>
        <li parentName="ul">{`[1D]`}{` Cathari`}</li>
        <li parentName="ul">{`[3D]`}{` Faylon`}</li>
      </ul>
    </Menu>
    <p>{`Leave Dahak.`}</p>
    <h4 {...{
      "id": "sialeeds-4000hp"
    }}>{`Sialeeds 4000HP`}</h4>
    <p>{`Striking Arrow`}</p>
    <p>{`Godwin Soldier: "As you wish, my lady!" 2m30s no input.`}</p>
    <p>{`Lucretia: "Yes, I know... We're not out of the woods yet." 2m45s until Option.`}</p>
    <p>{`Lucretia: "...And I want YOU to take command of this operation, Prince." Option 1 then 3m5s no input.`}</p>
    <h4 {...{
      "id": "war-battle-sol-falena-siege-part-2"
    }}>{`War Battle: Sol-Falena Siege Part 2`}</h4>
    <h5 {...{
      "id": "setup-5"
    }}>{`Setup`}</h5>
    <ul>
      <li parentName="ul">{`Fuwalafuwalu: Remove All`}</li>
    </ul>
    <h5 {...{
      "id": "strategy-11"
    }}>{`Strategy`}</h5>
    <ol>
      <li parentName="ol">{`[Hero]`}{`: Move to P1 (2 Up from starting tile)`}</li>
      <li parentName="ol">{`Move other 5 units to bottom right corner, watch Hero's unit. There is no need to rush this.`}</li>
      <li parentName="ol">{`[Hero]`}{`: Once Hero is standing on line on bridge, move to tile above Alenia (hard to click).`}</li>
      <li parentName="ol">{`[Dahak]`}{`: Watch east ship on left side, once it starts turning east, move Dahak like 20 tiles directly northwest. Can press R1 till Shula, then move Camera around. Next R1 will be on Dahak.`}</li>
    </ol>
    <h3 {...{
      "id": "sol-falena-4"
    }}>{`Sol-Falena`}</h3>
    <p>{`Talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-9"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Cathari: Party`}</li>
        <li parentName="ul">{`[2D]`}{` Dinn: Party`}</li>
        <li parentName="ul">{`[1U]`}{` Goesch: Party`}</li>
      </ul>
    </Menu>
    <p>{`Northeast to Palace.`}</p>
    <h4 {...{
      "id": "alenia-3000hp--zahhak-3300hp"
    }}>{`Alenia 3000HP & Zahhak 3300HP`}</h4>
    <p>{`True Men`}</p>
    <h4 {...{
      "id": "raging-alenia-4500hp--raging-zahhak-5000hp"
    }}>{`Raging Alenia 4500HP & Raging Zahhak 5000HP`}</h4>
    <p>{`True Men`}</p>
    <p>{`Northeast to Audience Chamber. After entering 3m45s no input before duel start.`}</p>
    <h4 {...{
      "id": "gizel-duel"
    }}>{`Gizel Duel`}</h4>
    <p>{`Special .8s faster.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`A weak attack like that would never...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All right, Prince, what do you think...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`And here's another one for you!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`First of all, let's see how you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heh heh heh...A little bit of tension..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`How about it? Think you can stop that..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I think I felt that one a little bit...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'd like for you to show me some of...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm not finished with you yet!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`It looks like we both were a little...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Let me see what you can do.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Let me show you how a big move is...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Let us calm things down a bit.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Looks like that wasn't quite enough...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Please don't disappoint me.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`That was just a flesh wound now it's...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`This is just a waste of time. Now...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`This time, I'll really finish you off!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`This time, why don't you make a move?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`This won't get us anywhere. Take this!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Time to finish you off!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Very nice, Prince. But our battle has..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Very nice, Prince. Maybe I should be..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Very nice, Prince...But it's not over..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Very nice...But do you think you can...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Very nice...Now I'll show you what I...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special / Super`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Why don't you try a steadier approach?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You should have shown me a move at...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You wouldn't let yourself get defeated..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Your Highness, you leave yourself...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`2m10s from last action to text.`}</p>
    <p>{`Leave Sun Room. Go to Audience Chamber. Leave Audience Chamber, talk to Luserina.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-10"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1D]`}{` Cathari: Party`}</li>
      </ul>
    </Menu>
    <p>{`Exit Sol-Falena through Southeast, TP `}<strong parentName="p">{`Lunas (3D)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "lunas-2"
    }}>{`Lunas`}</h3>
    <p>{`Go to where the Purification Rite was.`}</p>
    <h3 {...{
      "id": "ashtwal-mountains"
    }}>{`Ashtwal Mountains`}</h3>
    <p>{`If you didn't pick it up in Doraat, pick up `}<strong parentName="p">{`Blinking Rune Pc`}</strong>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/74029873c9e9f11520e8f4b0adace0a3/804b2/AshtwalMountains.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "128.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAYAAAC3g3x9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAEAUlEQVRIx3VViXIaRxDl/78hR1XiSiWOI1VccWInujgVEAhYFljuFccCyw2LOMVLv7FmLWQyVVN7zEz36/e6ewLLpYfRaCRzDM/zMJ1O1RwOh1gul+A4HA7+fDlef3MEHHeCcqWKB9tGu91GqVTCYDDAeDzGfD5Xm56envwD7VYTrVZb1hdHznyDXttFwTCRTKXQaDRQLBbhOA7W6/WRMTrI5XLIi8Pz8zS6Xe+0wWlrBDObg5EzfIPdbheTycTf1O/3kTNNrIQe9MeIxzPo9Zxng09H4QcWqynaThtOx4EtYZfLZYWm1+vBdV21yRZHw9kMqNuoxeMwi3ns93s/Am2Mz8BLgvWCYRiIxWKIRqPIpNOoiKPaTRBO7BbFRv1kqD5CPl8ubLcbpIRPItxvd0gLb3YoDOuPD7AqFUTCYbVGeiryTSH1INqANkYRGg1bEGWQz+eFpzjGkk7jzQaZX9+hJEhrDw+4vLhQPGezWYTF+PX1tdrri6JVNM08BkMXzZYtOShCiQhpQZr96yPu3/yEsqwbglajur+/R71eV8a4l//JvY+wVCrDHfZhlU0lwlQULVxcIvfbGbqi8l4cr1crHwnDJjU0xEm+mW6+wf1+B7fvwrJKCIWCKk0S0RjSZ+e4k5AnUj2k5fHxEYvFAplMBnd3d+osDfGd/wKnSuhBuCKCTqeD+W6LxM+/oCTC2BJqVw4zwVlRDJcZQc75bDabXxDy+YVPUx2q1Wrqu1ytYpXJfi49ccJcZbJTaRqjQHxXorzOI214t93i8Jy8NG4Il005lBUkr8eH9x/x723i2OCp0MUk3MUcwR9+ROL392j2pXoE2WfO92r/RtKqbFWlqganEW6E+HyxgI50IPPyCm0RJvLt9yhaFnpOF0M5eKqVnSw91VVETVMUM9+dIfXpbziFIuLJpDJ49ecnRG9CvgEqzrZHAdlL/zfkYjKF8vWNep9Lk6UIzDmrZCkl2ScZalOywQhHEJEc1I3kK4SeeDUEUT0YEgMl1ERhImCKVMRwUtZovFAoSM5aKl81uq9DpsJMEwnZ+kdqVirAFIUTiYSqBqYTB68IouasisOXjfgosQ/PPylI8JvvMJKDHDPphUTDw0x2PeiE1UEujxBq1bSXmXBkSVNg8TMHOVutluIuLV2H3YYdnXcPDeq7Rxl8Lf9QWlYiEsHGyEmDtpWKRMVwWV7s6uSPVcSQNQ0alELoeQtFPOuzKqjg9LCWRlGQb31Bsfh1aCw1zSUdHF2jzaaHt29vcXUlHUYuqpakRcsZIJ4ysJjP/NomKirMq4Ehb6U0GSpBMHzyy3oOVKvsHgXspKtorz259VbPaPQ/5h8bgr6z2RTILVsa2xlp4dp/eGGQ2cw/7TsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Ashtwal Mountains",
            "title": "Ashtwal Mountains",
            "src": "/static/74029873c9e9f11520e8f4b0adace0a3/804b2/AshtwalMountains.png",
            "srcSet": ["/static/74029873c9e9f11520e8f4b0adace0a3/8ff5a/AshtwalMountains.png 240w", "/static/74029873c9e9f11520e8f4b0adace0a3/804b2/AshtwalMountains.png 384w"],
            "sizes": "(max-width: 384px) 100vw, 384px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <ol>
      <li parentName="ol">{`Northwest`}</li>
      <li parentName="ol">{`Northwest`}</li>
      <li parentName="ol">{`Northeast, go across bridge`}</li>
      <li parentName="ol">{`Northwest`}</li>
      <li parentName="ol">{`North then Northeast`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "heros-party-1"
      }}>{`Hero's Party`}</h5>
      <ul>
        <li parentName="ul">{`[3D]`}{` Dinn`}</li>
        <li parentName="ul">{`[2R2D]`}{` Nifsara`}</li>
      </ul>
      <h5 {...{
        "id": "lyons-party"
      }}>{`Lyon's Party`}</h5>
      <ul>
        <li parentName="ul">{`[1U]`}{` Goesch`}</li>
        <li parentName="ul">{`[4D]`}{` Faylon`}</li>
        <li parentName="ul">{`[1R1U]`}{` Miakis`}</li>
        <li parentName="ul">{`[1L2U]`}{` Wabon: Entourage`}</li>
      </ul>
      <h5 {...{
        "id": "georgs-party"
      }}>{`Georg's Party`}</h5>
      <ul>
        <li parentName="ul">{`[3U]`}{` Galleon`}</li>
        <li parentName="ul">{`[1D]`}{` Cathari`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "ashtwal-ruins"
    }}>{`Ashtwal Ruins`}</h3>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Hero & Lyon`}</strong>{`: Move to blockade.`}</li>
      <li parentName="ol"><strong parentName="li">{`Zweig`}</strong>{`: Swap Zweig to Entourage. East at fork, move to blockade & switch to Lyon.`}</li>
      <li parentName="ol"><strong parentName="li">{`Lyon`}</strong>{`: Press switch, after going down elevator go left to blockade. Switch to Hero.`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: Press switch.`}</li>
      <li parentName="ol"><strong parentName="li">{`Lyon`}</strong>{`: Press switch, east to blockade.`}</li>
      <li parentName="ol"><strong parentName="li">{`Zweig`}</strong>{`: East up elevator, southeast at fork, press switch. Back to fork then north. West at fork, press switch, then north to blockade. Switch to Lyon.`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: Up elevator, follow path till blockade.`}</li>
      <li parentName="ol"><strong parentName="li">{`Lyon`}</strong>{`: North at fork, press switch, switch to Hero.`}</li>
      <li parentName="ol"><strong parentName="li">{`Hero`}</strong>{`: Press Switch. `}<strong parentName="li">{`Swap at switch.`}</strong></li>
      <li parentName="ol"><strong parentName="li">{`Lyon`}</strong>{`: North for fight.`}</li>
    </ol>
    <h4 {...{
      "id": "girtablulu-8500hp"
    }}>{`Girtablulu 8500HP`}</h4>
    <p>{`3 True Men, Striking Arrow`}</p>
    <p>{`North through corridor, auto switch to Zweig. North for fight.`}</p>
    <h4 {...{
      "id": "gudalim-8500hp"
    }}>{`Gudalim 8500HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Want to hit 2190 Average minimum to kill with Striking Arrow T4`}</p>
    </blockquote>
    <p>{`3 True Men, Striking Arrow or True Men`}</p>
    <p>{`North into corridor. `}<strong parentName="p">{`DO NOT ENTER NEXT ROOM`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Use Blinking Rune Pc, swap Cathari for anyone.`}</p>
    <p>{`Move to next room, auto switch to Hero.`}<br parentName="p"></br>{`
`}{`Use Blinking Rune Piece, swap Nifsara for Cathari.`}<br parentName="p"></br>{`
`}{`Follow path for next fight.`}</p>
    <h4 {...{
      "id": "enmesharra-8500hp"
    }}>{`Enmesharra 8500HP`}</h4>
    <p>{`True Men x2, Striking Arrow`}</p>
    <p>{`Georg: "Hero, Lyon! Take some of the party ahead with you!" `}<strong parentName="p">{`Option 2`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-11"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[] Cathari: Party`}</li>
        <li parentName="ul">{`[] Dinn: Party`}</li>
        <li parentName="ul">{`[] Faylon: Party`}</li>
        <li parentName="ul">{`[] Galleon: Party`}</li>
        <li parentName="ul">{`[] Goesch: Entourage (Skippable)`}</li>
        <li parentName="ul">{`[1U]`}{` Wabon: Entourage`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You can skip bringing Goesch if you want, still 3T kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "swap-17"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Lyon > Goesch`}</li>
      </ul>
      <h5 {...{
        "id": "equip-12"
      }}>{`Equip`}</h5>
      <ul>
        <li parentName="ul">{`Jizos`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "dolph-duel"
    }}>{`Dolph Duel`}</h4>
    <p>{`Guard and Special about same length.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Dialogue`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Opponent Action`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`A move like that was too much for you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Are you trying... How reckless of you.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Are you trying... It's not going to work`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Can you take another one?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Do you think you'll be able to do that..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Here I come. See how you hold up.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I really do wish you'd try a little...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I won't let you suffer long.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I'm a little surprised to see you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`If you can't even dodge a move like...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`If you're in that much pain, why...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`In your condition, this should be...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Is that the best you can do? A move...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Is that the best you can do? We'd...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`It's not over yet.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Let me give you the chance to realize...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Now it's my turn to make a move.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Simply withstanding my attacks will...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`So, you still... But will it last?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`So, you still... But can you withstand..`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Stalling for time? That won't save...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Still standing, huh? But can you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Still standing, huh? But will you be a`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`That was very good indeed, but it...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`The more time you waste, the more...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well, that was a surprise. Do you...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well, well. What a surprise. I didn't`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well, well. What a surprise. Maybe I...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Would you like a little break?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Would you like to try that again?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Guard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You can't even dodge a move like that?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You did very well. I guess I should...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special / Super`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You must be really feeling it by now.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Special`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Marscal: "Can you swear to me you'll pass the Sun Rune onto the next generation..." Option 1`}</p>
    <h5 {...{
      "id": "sun-incarnation-14000hp"
    }}>{`Sun Incarnation 14000HP`}</h5>
    <p>{`2 True Men, Striking Arrow.`}</p>
    <p>{`Split on fade out to black, GG`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      